// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -moz-appearance: none;
         appearance: none;
    -webkit-appearance: none;
    background-color: transparent;
    background-image: none;
    border-width: 0;
    border-style: solid;
    border-color: currentColor;
    color: inherit;
    cursor: pointer;
  }

  /* Flatten native text/search inputs; the design draws its own borders. */
  input:not([type='checkbox']):not([type='radio']),
  textarea {
    border-width: 0;
    border-style: solid;
    border-color: var(--border);
  }

  [type='search'] {
    -moz-appearance: none;
         appearance: none;
    -webkit-appearance: none;
  }
  [type='search']::-webkit-search-decoration,
  [type='search']::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }
.container {
    width: 100%;
}
@media (min-width: 640px) {
    .container {
        max-width: 640px;
    }
}
@media (min-width: 768px) {
    .container {
        max-width: 768px;
    }
}
@media (min-width: 1024px) {
    .container {
        max-width: 1024px;
    }
}
@media (min-width: 1280px) {
    .container {
        max-width: 1280px;
    }
}
@media (min-width: 1536px) {
    .container {
        max-width: 1536px;
    }
}
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}
.pointer-events-none {
    pointer-events: none;
}
.pointer-events-auto {
    pointer-events: auto;
}
.visible {
    visibility: visible;
}
.invisible {
    visibility: hidden;
}
.collapse {
    visibility: collapse;
}
.static {
    position: static;
}
.fixed {
    position: fixed;
}
.absolute {
    position: absolute;
}
.relative {
    position: relative;
}
.sticky {
    position: sticky;
}
.inset-0 {
    inset: 0px;
}
.inset-x-0 {
    left: 0px;
    right: 0px;
}
.inset-y-0 {
    top: 0px;
    bottom: 0px;
}
.inset-y-\\[3px\\] {
    top: 3px;
    bottom: 3px;
}
.-bottom-px {
    bottom: -1px;
}
.-left-\\[5px\\] {
    left: -5px;
}
.-right-\\[2px\\] {
    right: -2px;
}
.-top-\\[2px\\] {
    top: -2px;
}
.-top-\\[5px\\] {
    top: -5px;
}
.bottom-0 {
    bottom: 0px;
}
.bottom-full {
    bottom: 100%;
}
.left-0 {
    left: 0px;
}
.left-1\\/2 {
    left: 50%;
}
.left-7 {
    left: 1.75rem;
}
.left-\\[10px\\] {
    left: 10px;
}
.left-\\[11px\\] {
    left: 11px;
}
.left-\\[19px\\] {
    left: 19px;
}
.left-\\[3px\\] {
    left: 3px;
}
.left-\\[calc\\(50vw-var\\(--sidebar-w\\)\\)\\] {
    left: calc(50vw - var(--sidebar-w));
}
.right-0 {
    right: 0px;
}
.right-1\\.5 {
    right: 0.375rem;
}
.right-2 {
    right: 0.5rem;
}
.right-5 {
    right: 1.25rem;
}
.right-6 {
    right: 1.5rem;
}
.top-0 {
    top: 0px;
}
.top-1\\/2 {
    top: 50%;
}
.top-3 {
    top: 0.75rem;
}
.top-6 {
    top: 1.5rem;
}
.top-\\[-120px\\] {
    top: -120px;
}
.top-\\[46px\\] {
    top: 46px;
}
.top-\\[90px\\] {
    top: 90px;
}
.top-\\[calc\\(100\\%\\+10px\\)\\] {
    top: calc(100% + 10px);
}
.top-\\[calc\\(100\\%\\+12px\\)\\] {
    top: calc(100% + 12px);
}
.top-\\[calc\\(100\\%\\+4px\\)\\] {
    top: calc(100% + 4px);
}
.top-\\[calc\\(100\\%\\+6px\\)\\] {
    top: calc(100% + 6px);
}
.top-\\[calc\\(100\\%\\+8px\\)\\] {
    top: calc(100% + 8px);
}
.z-0 {
    z-index: 0;
}
.z-10 {
    z-index: 10;
}
.z-20 {
    z-index: 20;
}
.z-30 {
    z-index: 30;
}
.z-40 {
    z-index: 40;
}
.z-50 {
    z-index: 50;
}
.z-\\[100\\] {
    z-index: 100;
}
.z-\\[120\\] {
    z-index: 120;
}
.z-\\[125\\] {
    z-index: 125;
}
.z-\\[130\\] {
    z-index: 130;
}
.z-\\[1\\] {
    z-index: 1;
}
.z-\\[2\\] {
    z-index: 2;
}
.z-\\[3\\] {
    z-index: 3;
}
.z-\\[42\\] {
    z-index: 42;
}
.z-\\[5\\] {
    z-index: 5;
}
.col-span-2 {
    grid-column: span 2 / span 2;
}
.col-span-full {
    grid-column: 1 / -1;
}
.m-0 {
    margin: 0px;
}
.-mx-1 {
    margin-left: -0.25rem;
    margin-right: -0.25rem;
}
.mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
}
.mx-auto {
    margin-left: auto;
    margin-right: auto;
}
.my-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
}
.my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}
.my-2\\.5 {
    margin-top: 0.625rem;
    margin-bottom: 0.625rem;
}
.my-3 {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
}
.my-\\[6px\\] {
    margin-top: 6px;
    margin-bottom: 6px;
}
.-mb-px {
    margin-bottom: -1px;
}
.-mt-1 {
    margin-top: -0.25rem;
}
.-mt-\\[14px\\] {
    margin-top: -14px;
}
.mb-0 {
    margin-bottom: 0px;
}
.mb-1 {
    margin-bottom: 0.25rem;
}
.mb-1\\.5 {
    margin-bottom: 0.375rem;
}
.mb-2 {
    margin-bottom: 0.5rem;
}
.mb-3 {
    margin-bottom: 0.75rem;
}
.mb-4 {
    margin-bottom: 1rem;
}
.mb-5 {
    margin-bottom: 1.25rem;
}
.mb-6 {
    margin-bottom: 1.5rem;
}
.mb-\\[12px\\] {
    margin-bottom: 12px;
}
.mb-\\[14px\\] {
    margin-bottom: 14px;
}
.mb-\\[2px\\] {
    margin-bottom: 2px;
}
.mb-\\[6px\\] {
    margin-bottom: 6px;
}
.ml-0\\.5 {
    margin-left: 0.125rem;
}
.ml-1 {
    margin-left: 0.25rem;
}
.ml-1\\.5 {
    margin-left: 0.375rem;
}
.ml-2 {
    margin-left: 0.5rem;
}
.ml-\\[26px\\] {
    margin-left: 26px;
}
.ml-\\[6px\\] {
    margin-left: 6px;
}
.ml-auto {
    margin-left: auto;
}
.mr-1 {
    margin-right: 0.25rem;
}
.mr-1\\.5 {
    margin-right: 0.375rem;
}
.mr-2 {
    margin-right: 0.5rem;
}
.mr-auto {
    margin-right: auto;
}
.mt-0\\.5 {
    margin-top: 0.125rem;
}
.mt-1 {
    margin-top: 0.25rem;
}
.mt-1\\.5 {
    margin-top: 0.375rem;
}
.mt-10 {
    margin-top: 2.5rem;
}
.mt-12 {
    margin-top: 3rem;
}
.mt-14 {
    margin-top: 3.5rem;
}
.mt-16 {
    margin-top: 4rem;
}
.mt-2 {
    margin-top: 0.5rem;
}
.mt-2\\.5 {
    margin-top: 0.625rem;
}
.mt-3 {
    margin-top: 0.75rem;
}
.mt-3\\.5 {
    margin-top: 0.875rem;
}
.mt-4 {
    margin-top: 1rem;
}
.mt-5 {
    margin-top: 1.25rem;
}
.mt-6 {
    margin-top: 1.5rem;
}
.mt-7 {
    margin-top: 1.75rem;
}
.mt-9 {
    margin-top: 2.25rem;
}
.mt-\\[10px\\] {
    margin-top: 10px;
}
.mt-\\[12px\\] {
    margin-top: 12px;
}
.mt-\\[14px\\] {
    margin-top: 14px;
}
.mt-\\[16px\\] {
    margin-top: 16px;
}
.mt-\\[18px\\] {
    margin-top: 18px;
}
.mt-\\[1px\\] {
    margin-top: 1px;
}
.mt-\\[22px\\] {
    margin-top: 22px;
}
.mt-\\[26px\\] {
    margin-top: 26px;
}
.mt-\\[2px\\] {
    margin-top: 2px;
}
.mt-\\[30px\\] {
    margin-top: 30px;
}
.mt-\\[3px\\] {
    margin-top: 3px;
}
.mt-\\[40px\\] {
    margin-top: 40px;
}
.mt-\\[56px\\] {
    margin-top: 56px;
}
.mt-\\[5px\\] {
    margin-top: 5px;
}
.mt-\\[6px\\] {
    margin-top: 6px;
}
.mt-\\[7px\\] {
    margin-top: 7px;
}
.mt-\\[8px\\] {
    margin-top: 8px;
}
.mt-\\[9px\\] {
    margin-top: 9px;
}
.mt-auto {
    margin-top: auto;
}
.mt-px {
    margin-top: 1px;
}
.line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.block {
    display: block;
}
.inline-block {
    display: inline-block;
}
.inline {
    display: inline;
}
.flex {
    display: flex;
}
.inline-flex {
    display: inline-flex;
}
.table {
    display: table;
}
.\\!grid {
    display: grid !important;
}
.grid {
    display: grid;
}
.contents {
    display: contents;
}
.hidden {
    display: none;
}
.h-0 {
    height: 0px;
}
.h-10 {
    height: 2.5rem;
}
.h-11 {
    height: 2.75rem;
}
.h-14 {
    height: 3.5rem;
}
.h-16 {
    height: 4rem;
}
.h-2 {
    height: 0.5rem;
}
.h-3\\.5 {
    height: 0.875rem;
}
.h-4 {
    height: 1rem;
}
.h-5 {
    height: 1.25rem;
}
.h-6 {
    height: 1.5rem;
}
.h-7 {
    height: 1.75rem;
}
.h-8 {
    height: 2rem;
}
.h-9 {
    height: 2.25rem;
}
.h-\\[10px\\] {
    height: 10px;
}
.h-\\[11px\\] {
    height: 11px;
}
.h-\\[12px\\] {
    height: 12px;
}
.h-\\[136px\\] {
    height: 136px;
}
.h-\\[13px\\] {
    height: 13px;
}
.h-\\[14px\\] {
    height: 14px;
}
.h-\\[15px\\] {
    height: 15px;
}
.h-\\[160px\\] {
    height: 160px;
}
.h-\\[168px\\] {
    height: 168px;
}
.h-\\[16px\\] {
    height: 16px;
}
.h-\\[17px\\] {
    height: 17px;
}
.h-\\[18px\\] {
    height: 18px;
}
.h-\\[19px\\] {
    height: 19px;
}
.h-\\[200px\\] {
    height: 200px;
}
.h-\\[20px\\] {
    height: 20px;
}
.h-\\[220px\\] {
    height: 220px;
}
.h-\\[22px\\] {
    height: 22px;
}
.h-\\[230px\\] {
    height: 230px;
}
.h-\\[24px\\] {
    height: 24px;
}
.h-\\[26px\\] {
    height: 26px;
}
.h-\\[28px\\] {
    height: 28px;
}
.h-\\[2px\\] {
    height: 2px;
}
.h-\\[300px\\] {
    height: 300px;
}
.h-\\[30px\\] {
    height: 30px;
}
.h-\\[32px\\] {
    height: 32px;
}
.h-\\[34px\\] {
    height: 34px;
}
.h-\\[38px\\] {
    height: 38px;
}
.h-\\[40px\\] {
    height: 40px;
}
.h-\\[420px\\] {
    height: 420px;
}
.h-\\[44px\\] {
    height: 44px;
}
.h-\\[46px\\] {
    height: 46px;
}
.h-\\[4px\\] {
    height: 4px;
}
.h-\\[528px\\] {
    height: 528px;
}
.h-\\[52px\\] {
    height: 52px;
}
.h-\\[5px\\] {
    height: 5px;
}
.h-\\[660px\\] {
    height: 660px;
}
.h-\\[6px\\] {
    height: 6px;
}
.h-\\[7px\\] {
    height: 7px;
}
.h-\\[8px\\] {
    height: 8px;
}
.h-\\[9px\\] {
    height: 9px;
}
.h-auto {
    height: auto;
}
.h-full {
    height: 100%;
}
.h-px {
    height: 1px;
}
.h-screen {
    height: 100vh;
}
.max-h-\\[190px\\] {
    max-height: 190px;
}
.max-h-\\[200px\\] {
    max-height: 200px;
}
.max-h-\\[220px\\] {
    max-height: 220px;
}
.max-h-\\[240px\\] {
    max-height: 240px;
}
.max-h-\\[260px\\] {
    max-height: 260px;
}
.max-h-\\[300px\\] {
    max-height: 300px;
}
.max-h-\\[320px\\] {
    max-height: 320px;
}
.max-h-\\[340px\\] {
    max-height: 340px;
}
.max-h-\\[440px\\] {
    max-height: 440px;
}
.max-h-\\[46\\%\\] {
    max-height: 46%;
}
.max-h-\\[560px\\] {
    max-height: 560px;
}
.max-h-\\[62\\%\\] {
    max-height: 62%;
}
.max-h-\\[70vh\\] {
    max-height: 70vh;
}
.max-h-\\[85vh\\] {
    max-height: 85vh;
}
.max-h-\\[86vh\\] {
    max-height: 86vh;
}
.max-h-\\[88vh\\] {
    max-height: 88vh;
}
.max-h-\\[calc\\(100vh-480px\\)\\] {
    max-height: calc(100vh - 480px);
}
.max-h-\\[min\\(70vh\\2c 560px\\)\\] {
    max-height: min(70vh, 560px);
}
.min-h-0 {
    min-height: 0px;
}
.min-h-\\[112px\\] {
    min-height: 112px;
}
.min-h-\\[120px\\] {
    min-height: 120px;
}
.min-h-\\[160px\\] {
    min-height: 160px;
}
.min-h-\\[220px\\] {
    min-height: 220px;
}
.min-h-\\[240px\\] {
    min-height: 240px;
}
.min-h-\\[24px\\] {
    min-height: 24px;
}
.min-h-\\[320px\\] {
    min-height: 320px;
}
.min-h-\\[34px\\] {
    min-height: 34px;
}
.min-h-\\[46px\\] {
    min-height: 46px;
}
.min-h-\\[60vh\\] {
    min-height: 60vh;
}
.min-h-\\[96px\\] {
    min-height: 96px;
}
.min-h-full {
    min-height: 100%;
}
.min-h-screen {
    min-height: 100vh;
}
.\\!w-\\[150px\\] {
    width: 150px !important;
}
.w-0 {
    width: 0px;
}
.w-10 {
    width: 2.5rem;
}
.w-11 {
    width: 2.75rem;
}
.w-14 {
    width: 3.5rem;
}
.w-2 {
    width: 0.5rem;
}
.w-3\\.5 {
    width: 0.875rem;
}
.w-4 {
    width: 1rem;
}
.w-5 {
    width: 1.25rem;
}
.w-6 {
    width: 1.5rem;
}
.w-7 {
    width: 1.75rem;
}
.w-8 {
    width: 2rem;
}
.w-9 {
    width: 2.25rem;
}
.w-\\[10px\\] {
    width: 10px;
}
.w-\\[11px\\] {
    width: 11px;
}
.w-\\[120px\\] {
    width: 120px;
}
.w-\\[12px\\] {
    width: 12px;
}
.w-\\[130px\\] {
    width: 130px;
}
.w-\\[132\\%\\] {
    width: 132%;
}
.w-\\[13px\\] {
    width: 13px;
}
.w-\\[14px\\] {
    width: 14px;
}
.w-\\[150px\\] {
    width: 150px;
}
.w-\\[15px\\] {
    width: 15px;
}
.w-\\[16px\\] {
    width: 16px;
}
.w-\\[170px\\] {
    width: 170px;
}
.w-\\[17px\\] {
    width: 17px;
}
.w-\\[18px\\] {
    width: 18px;
}
.w-\\[19px\\] {
    width: 19px;
}
.w-\\[20px\\] {
    width: 20px;
}
.w-\\[210px\\] {
    width: 210px;
}
.w-\\[22px\\] {
    width: 22px;
}
.w-\\[230px\\] {
    width: 230px;
}
.w-\\[240px\\] {
    width: 240px;
}
.w-\\[248px\\] {
    width: 248px;
}
.w-\\[24px\\] {
    width: 24px;
}
.w-\\[26px\\] {
    width: 26px;
}
.w-\\[280px\\] {
    width: 280px;
}
.w-\\[28px\\] {
    width: 28px;
}
.w-\\[2px\\] {
    width: 2px;
}
.w-\\[30px\\] {
    width: 30px;
}
.w-\\[320px\\] {
    width: 320px;
}
.w-\\[32px\\] {
    width: 32px;
}
.w-\\[340px\\] {
    width: 340px;
}
.w-\\[34px\\] {
    width: 34px;
}
.w-\\[360px\\] {
    width: 360px;
}
.w-\\[38px\\] {
    width: 38px;
}
.w-\\[3px\\] {
    width: 3px;
}
.w-\\[40px\\] {
    width: 40px;
}
.w-\\[44px\\] {
    width: 44px;
}
.w-\\[460px\\] {
    width: 460px;
}
.w-\\[46px\\] {
    width: 46px;
}
.w-\\[4px\\] {
    width: 4px;
}
.w-\\[540px\\] {
    width: 540px;
}
.w-\\[560px\\] {
    width: 560px;
}
.w-\\[58px\\] {
    width: 58px;
}
.w-\\[5px\\] {
    width: 5px;
}
.w-\\[640px\\] {
    width: 640px;
}
.w-\\[64px\\] {
    width: 64px;
}
.w-\\[68px\\] {
    width: 68px;
}
.w-\\[6px\\] {
    width: 6px;
}
.w-\\[7px\\] {
    width: 7px;
}
.w-\\[8px\\] {
    width: 8px;
}
.w-\\[9px\\] {
    width: 9px;
}
.w-\\[calc\\(50\\%-3px\\)\\] {
    width: calc(50% - 3px);
}
.w-\\[min\\(360px\\2c calc\\(100vw-40px\\)\\)\\] {
    width: min(360px, calc(100vw - 40px));
}
.w-\\[min\\(400px\\2c 36vw\\)\\] {
    width: min(400px, 36vw);
}
.w-\\[min\\(400px\\2c calc\\(100vw-48px\\)\\)\\] {
    width: min(400px, calc(100vw - 48px));
}
.w-\\[min\\(460px\\2c calc\\(100vw-48px\\)\\)\\] {
    width: min(460px, calc(100vw - 48px));
}
.w-\\[min\\(720px\\2c calc\\(100vw-64px\\)\\)\\] {
    width: min(720px, calc(100vw - 64px));
}
.w-fit {
    width: -moz-fit-content;
    width: fit-content;
}
.w-full {
    width: 100%;
}
.w-max {
    width: -moz-max-content;
    width: max-content;
}
.min-w-0 {
    min-width: 0px;
}
.min-w-\\[120px\\] {
    min-width: 120px;
}
.min-w-\\[130px\\] {
    min-width: 130px;
}
.min-w-\\[150px\\] {
    min-width: 150px;
}
.min-w-\\[160px\\] {
    min-width: 160px;
}
.min-w-\\[17px\\] {
    min-width: 17px;
}
.min-w-\\[180px\\] {
    min-width: 180px;
}
.min-w-\\[200px\\] {
    min-width: 200px;
}
.min-w-\\[220px\\] {
    min-width: 220px;
}
.min-w-\\[240px\\] {
    min-width: 240px;
}
.min-w-\\[244px\\] {
    min-width: 244px;
}
.min-w-\\[260px\\] {
    min-width: 260px;
}
.min-w-\\[3px\\] {
    min-width: 3px;
}
.min-w-\\[520px\\] {
    min-width: 520px;
}
.min-w-\\[640px\\] {
    min-width: 640px;
}
.min-w-full {
    min-width: 100%;
}
.min-w-max {
    min-width: -moz-max-content;
    min-width: max-content;
}
.max-w-\\[1100px\\] {
    max-width: 1100px;
}
.max-w-\\[1180px\\] {
    max-width: 1180px;
}
.max-w-\\[120px\\] {
    max-width: 120px;
}
.max-w-\\[1400px\\] {
    max-width: 1400px;
}
.max-w-\\[160px\\] {
    max-width: 160px;
}
.max-w-\\[168px\\] {
    max-width: 168px;
}
.max-w-\\[21ch\\] {
    max-width: 21ch;
}
.max-w-\\[220px\\] {
    max-width: 220px;
}
.max-w-\\[260px\\] {
    max-width: 260px;
}
.max-w-\\[280px\\] {
    max-width: 280px;
}
.max-w-\\[320px\\] {
    max-width: 320px;
}
.max-w-\\[34ch\\] {
    max-width: 34ch;
}
.max-w-\\[360px\\] {
    max-width: 360px;
}
.max-w-\\[380px\\] {
    max-width: 380px;
}
.max-w-\\[400px\\] {
    max-width: 400px;
}
.max-w-\\[420px\\] {
    max-width: 420px;
}
.max-w-\\[440px\\] {
    max-width: 440px;
}
.max-w-\\[460px\\] {
    max-width: 460px;
}
.max-w-\\[54ch\\] {
    max-width: 54ch;
}
.max-w-\\[560px\\] {
    max-width: 560px;
}
.max-w-\\[600px\\] {
    max-width: 600px;
}
.max-w-\\[640px\\] {
    max-width: 640px;
}
.max-w-\\[680px\\] {
    max-width: 680px;
}
.max-w-\\[760px\\] {
    max-width: 760px;
}
.max-w-\\[78\\%\\] {
    max-width: 78%;
}
.max-w-\\[780px\\] {
    max-width: 780px;
}
.max-w-\\[7px\\] {
    max-width: 7px;
}
.max-w-\\[840px\\] {
    max-width: 840px;
}
.max-w-\\[85\\%\\] {
    max-width: 85%;
}
.max-w-\\[860px\\] {
    max-width: 860px;
}
.max-w-\\[86vw\\] {
    max-width: 86vw;
}
.max-w-\\[88\\%\\] {
    max-width: 88%;
}
.max-w-\\[880px\\] {
    max-width: 880px;
}
.max-w-\\[900px\\] {
    max-width: 900px;
}
.max-w-\\[calc\\(100vw-32px\\)\\] {
    max-width: calc(100vw - 32px);
}
.max-w-\\[min\\(100\\%\\2c 360px\\)\\] {
    max-width: min(100%, 360px);
}
.max-w-\\[min\\(320px\\2c calc\\(100vw-24px\\)\\)\\] {
    max-width: min(320px, calc(100vw - 24px));
}
.max-w-\\[min\\(460px\\2c 80vw\\)\\] {
    max-width: min(460px, 80vw);
}
.max-w-full {
    max-width: 100%;
}
.flex-1 {
    flex: 1 1 0%;
}
.flex-none {
    flex: none;
}
.flex-shrink {
    flex-shrink: 1;
}
.flex-shrink-0 {
    flex-shrink: 0;
}
.shrink {
    flex-shrink: 1;
}
.shrink-0 {
    flex-shrink: 0;
}
.grow {
    flex-grow: 1;
}
.basis-1\\/2 {
    flex-basis: 50%;
}
.border-collapse {
    border-collapse: collapse;
}
.origin-left {
    transform-origin: left;
}
.origin-top-right {
    transform-origin: top right;
}
.-translate-x-1\\/2 {
    --tw-translate-x: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-full {
    --tw-translate-x: -100%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
    --tw-translate-y: -50%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-\\[calc\\(100\\%\\+10px\\)\\] {
    --tw-translate-y: calc(calc(100% + 10px) * -1);
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
    --tw-translate-x: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full {
    --tw-translate-x: 100%;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-0 {
    --tw-translate-y: 0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[24px\\] {
    --tw-translate-y: 24px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[2px\\] {
    --tw-translate-y: 2px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
    --tw-rotate: -90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
    --tw-rotate: 180deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
    --tw-rotate: 45deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90 {
    --tw-rotate: 90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100 {
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-50 {
    --tw-scale-x: .5;
    --tw-scale-y: .5;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-0 {
    --tw-scale-x: 0;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-x-100 {
    --tw-scale-x: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.animate-\\[barGrow_0\\.55s_cubic-bezier\\(0\\.22\\2c 1\\2c 0\\.36\\2c 1\\)_both\\] {
    animation: barGrow 0.55s cubic-bezier(0.22,1,0.36,1) both;
}
.animate-\\[barGrow_0\\.6s_cubic-bezier\\(0\\.22\\2c 1\\2c 0\\.36\\2c 1\\)_both\\] {
    animation: barGrow 0.6s cubic-bezier(0.22,1,0.36,1) both;
}
.animate-\\[menuHide_0\\.14s_ease-in_forwards\\] {
    animation: menuHide 0.14s ease-in forwards;
}
.animate-\\[menuReveal_0\\.16s_ease\\] {
    animation: menuReveal 0.16s ease;
}
.animate-\\[tabIn_0\\.28s_cubic-bezier\\(0\\.22\\2c 1\\2c 0\\.36\\2c 1\\)\\] {
    animation: tabIn 0.28s cubic-bezier(0.22,1,0.36,1);
}
.animate-\\[toastIn_0\\.18s_ease\\] {
    animation: toastIn 0.18s ease;
}
.animate-\\[toastIn_0\\.22s_ease\\] {
    animation: toastIn 0.22s ease;
}
@keyframes bounce {
    0%, 100% {
        transform: translateY(-25%);
        animation-timing-function: cubic-bezier(0.8,0,1,1);
    }
    50% {
        transform: none;
        animation-timing-function: cubic-bezier(0,0,0.2,1);
    }
}
.animate-bounce {
    animation: bounce 1s infinite;
}
@keyframes pulse {
    50% {
        opacity: .5;
    }
}
.animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
.animate-spin {
    animation: spin 1s linear infinite;
}
.cursor-col-resize {
    cursor: col-resize;
}
.cursor-default {
    cursor: default;
}
.cursor-grab {
    cursor: grab;
}
.cursor-help {
    cursor: help;
}
.cursor-not-allowed {
    cursor: not-allowed;
}
.cursor-pointer {
    cursor: pointer;
}
.cursor-text {
    cursor: text;
}
.touch-none {
    touch-action: none;
}
.select-none {
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
}
.resize-none {
    resize: none;
}
.resize-y {
    resize: vertical;
}
.resize {
    resize: both;
}
.list-decimal {
    list-style-type: decimal;
}
.list-disc {
    list-style-type: disc;
}
.list-none {
    list-style-type: none;
}
.appearance-none {
    -webkit-appearance: none;
       -moz-appearance: none;
            appearance: none;
}
.grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-\\[120px_1fr_56px\\] {
    grid-template-columns: 120px 1fr 56px;
}
.grid-cols-\\[1fr_180px_220px\\] {
    grid-template-columns: 1fr 180px 220px;
}
.grid-cols-\\[1fr_220px\\] {
    grid-template-columns: 1fr 220px;
}
.grid-cols-\\[56px_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: 56px minmax(0,1fr);
}
.grid-cols-\\[minmax\\(0\\2c 1\\.1fr\\)_minmax\\(0\\2c 1fr\\)_200px\\] {
    grid-template-columns: minmax(0,1.1fr) minmax(0,1fr) 200px;
}
.grid-cols-\\[minmax\\(0\\2c 1\\.45fr\\)_minmax\\(0\\2c 1fr\\)\\] {
    grid-template-columns: minmax(0,1.45fr) minmax(0,1fr);
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1\\.45fr\\)\\] {
    grid-template-columns: minmax(0,1fr) minmax(0,1.45fr);
}
.grid-rows-\\[0fr\\] {
    grid-template-rows: 0fr;
}
.grid-rows-\\[1fr\\] {
    grid-template-rows: 1fr;
}
.flex-row-reverse {
    flex-direction: row-reverse;
}
.flex-col {
    flex-direction: column;
}
.flex-wrap {
    flex-wrap: wrap;
}
.place-items-center {
    place-items: center;
}
.items-start {
    align-items: flex-start;
}
.items-end {
    align-items: flex-end;
}
.items-center {
    align-items: center;
}
.items-baseline {
    align-items: baseline;
}
.items-stretch {
    align-items: stretch;
}
.justify-start {
    justify-content: flex-start;
}
.justify-end {
    justify-content: flex-end;
}
.justify-center {
    justify-content: center;
}
.justify-between {
    justify-content: space-between;
}
.gap-1 {
    gap: 0.25rem;
}
.gap-1\\.5 {
    gap: 0.375rem;
}
.gap-10 {
    gap: 2.5rem;
}
.gap-2 {
    gap: 0.5rem;
}
.gap-3 {
    gap: 0.75rem;
}
.gap-4 {
    gap: 1rem;
}
.gap-5 {
    gap: 1.25rem;
}
.gap-6 {
    gap: 1.5rem;
}
.gap-\\[10px\\] {
    gap: 10px;
}
.gap-\\[6px\\] {
    gap: 6px;
}
.gap-px {
    gap: 1px;
}
.gap-x-0\\.5 {
    -moz-column-gap: 0.125rem;
         column-gap: 0.125rem;
}
.gap-x-1 {
    -moz-column-gap: 0.25rem;
         column-gap: 0.25rem;
}
.gap-x-1\\.5 {
    -moz-column-gap: 0.375rem;
         column-gap: 0.375rem;
}
.gap-x-2 {
    -moz-column-gap: 0.5rem;
         column-gap: 0.5rem;
}
.gap-x-2\\.5 {
    -moz-column-gap: 0.625rem;
         column-gap: 0.625rem;
}
.gap-x-3 {
    -moz-column-gap: 0.75rem;
         column-gap: 0.75rem;
}
.gap-x-4 {
    -moz-column-gap: 1rem;
         column-gap: 1rem;
}
.gap-x-5 {
    -moz-column-gap: 1.25rem;
         column-gap: 1.25rem;
}
.gap-x-6 {
    -moz-column-gap: 1.5rem;
         column-gap: 1.5rem;
}
.gap-x-8 {
    -moz-column-gap: 2rem;
         column-gap: 2rem;
}
.gap-x-9 {
    -moz-column-gap: 2.25rem;
         column-gap: 2.25rem;
}
.gap-x-\\[10px\\] {
    -moz-column-gap: 10px;
         column-gap: 10px;
}
.gap-x-\\[11px\\] {
    -moz-column-gap: 11px;
         column-gap: 11px;
}
.gap-x-\\[12px\\] {
    -moz-column-gap: 12px;
         column-gap: 12px;
}
.gap-x-\\[14px\\] {
    -moz-column-gap: 14px;
         column-gap: 14px;
}
.gap-x-\\[22px\\] {
    -moz-column-gap: 22px;
         column-gap: 22px;
}
.gap-x-\\[2px\\] {
    -moz-column-gap: 2px;
         column-gap: 2px;
}
.gap-x-\\[3px\\] {
    -moz-column-gap: 3px;
         column-gap: 3px;
}
.gap-x-\\[5px\\] {
    -moz-column-gap: 5px;
         column-gap: 5px;
}
.gap-x-\\[6px\\] {
    -moz-column-gap: 6px;
         column-gap: 6px;
}
.gap-x-\\[7px\\] {
    -moz-column-gap: 7px;
         column-gap: 7px;
}
.gap-x-\\[9px\\] {
    -moz-column-gap: 9px;
         column-gap: 9px;
}
.gap-x-px {
    -moz-column-gap: 1px;
         column-gap: 1px;
}
.gap-y-0 {
    row-gap: 0px;
}
.gap-y-0\\.5 {
    row-gap: 0.125rem;
}
.gap-y-1 {
    row-gap: 0.25rem;
}
.gap-y-1\\.5 {
    row-gap: 0.375rem;
}
.gap-y-10 {
    row-gap: 2.5rem;
}
.gap-y-16 {
    row-gap: 4rem;
}
.gap-y-2 {
    row-gap: 0.5rem;
}
.gap-y-2\\.5 {
    row-gap: 0.625rem;
}
.gap-y-3 {
    row-gap: 0.75rem;
}
.gap-y-4 {
    row-gap: 1rem;
}
.gap-y-5 {
    row-gap: 1.25rem;
}
.gap-y-6 {
    row-gap: 1.5rem;
}
.gap-y-\\[10px\\] {
    row-gap: 10px;
}
.gap-y-\\[14px\\] {
    row-gap: 14px;
}
.gap-y-\\[22px\\] {
    row-gap: 22px;
}
.gap-y-\\[2px\\] {
    row-gap: 2px;
}
.gap-y-\\[6px\\] {
    row-gap: 6px;
}
.gap-y-\\[7px\\] {
    row-gap: 7px;
}
.gap-y-\\[9px\\] {
    row-gap: 9px;
}
.gap-y-px {
    row-gap: 1px;
}
.self-start {
    align-self: flex-start;
}
.self-end {
    align-self: flex-end;
}
.overflow-auto {
    overflow: auto;
}
.overflow-hidden {
    overflow: hidden;
}
.overflow-visible {
    overflow: visible;
}
.overflow-x-auto {
    overflow-x: auto;
}
.overflow-y-auto {
    overflow-y: auto;
}
.truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.text-ellipsis {
    text-overflow: ellipsis;
}
.whitespace-nowrap {
    white-space: nowrap;
}
.whitespace-pre {
    white-space: pre;
}
.whitespace-pre-line {
    white-space: pre-line;
}
.whitespace-pre-wrap {
    white-space: pre-wrap;
}
.break-words {
    overflow-wrap: break-word;
}
.break-all {
    word-break: break-all;
}
.\\!rounded-\\[10px\\] {
    border-radius: 10px !important;
}
.rounded {
    border-radius: var(--radius);
}
.rounded-\\[10px\\] {
    border-radius: 10px;
}
.rounded-\\[11px\\] {
    border-radius: 11px;
}
.rounded-\\[12px\\] {
    border-radius: 12px;
}
.rounded-\\[14px\\] {
    border-radius: 14px;
}
.rounded-\\[16px\\] {
    border-radius: 16px;
}
.rounded-\\[18px\\] {
    border-radius: 18px;
}
.rounded-\\[1px\\] {
    border-radius: 1px;
}
.rounded-\\[20px\\] {
    border-radius: 20px;
}
.rounded-\\[22px\\] {
    border-radius: 22px;
}
.rounded-\\[24px\\] {
    border-radius: 24px;
}
.rounded-\\[26px\\] {
    border-radius: 26px;
}
.rounded-\\[28px\\] {
    border-radius: 28px;
}
.rounded-\\[2px\\] {
    border-radius: 2px;
}
.rounded-\\[3px\\] {
    border-radius: 3px;
}
.rounded-\\[4px\\] {
    border-radius: 4px;
}
.rounded-\\[5px\\] {
    border-radius: 5px;
}
.rounded-\\[6px\\] {
    border-radius: 6px;
}
.rounded-\\[7px\\] {
    border-radius: 7px;
}
.rounded-\\[8px\\] {
    border-radius: 8px;
}
.rounded-\\[9px\\] {
    border-radius: 9px;
}
.rounded-full {
    border-radius: 9999px;
}
.rounded-b-\\[12px\\] {
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
}
.rounded-t-\\[12px\\] {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}
.rounded-bl-\\[4px\\] {
    border-bottom-left-radius: 4px;
}
.rounded-bl-\\[6px\\] {
    border-bottom-left-radius: 6px;
}
.rounded-br-\\[4px\\] {
    border-bottom-right-radius: 4px;
}
.rounded-br-\\[6px\\] {
    border-bottom-right-radius: 6px;
}
.border {
    border-width: 1px;
}
.border-0 {
    border-width: 0px;
}
.border-\\[1\\.5px\\] {
    border-width: 1.5px;
}
.border-b {
    border-bottom-width: 1px;
}
.border-b-2 {
    border-bottom-width: 2px;
}
.border-l {
    border-left-width: 1px;
}
.border-r {
    border-right-width: 1px;
}
.border-t {
    border-top-width: 1px;
}
.border-t-0 {
    border-top-width: 0px;
}
.border-t-2 {
    border-top-width: 2px;
}
.border-solid {
    border-style: solid;
}
.border-dashed {
    border-style: dashed;
}
.border-none {
    border-style: none;
}
.\\!border-danger {
    --tw-border-opacity: 1 !important;
    border-color: rgb(220 38 38 / var(--tw-border-opacity, 1)) !important;
}
.border-\\[\\#333333\\] {
    --tw-border-opacity: 1;
    border-color: rgb(51 51 51 / var(--tw-border-opacity, 1));
}
.border-\\[\\#3C87F7\\] {
    --tw-border-opacity: 1;
    border-color: rgb(60 135 247 / var(--tw-border-opacity, 1));
}
.border-\\[\\#bbf7d0\\] {
    --tw-border-opacity: 1;
    border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-\\[\\#bfdcff\\] {
    --tw-border-opacity: 1;
    border-color: rgb(191 220 255 / var(--tw-border-opacity, 1));
}
.border-\\[\\#cbd5e1\\] {
    --tw-border-opacity: 1;
    border-color: rgb(203 213 225 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e6e9ef\\] {
    --tw-border-opacity: 1;
    border-color: rgb(230 233 239 / var(--tw-border-opacity, 1));
}
.border-\\[\\#eef1f6\\] {
    --tw-border-opacity: 1;
    border-color: rgb(238 241 246 / var(--tw-border-opacity, 1));
}
.border-\\[\\#fde68a\\] {
    --tw-border-opacity: 1;
    border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-\\[\\#fecaca\\] {
    --tw-border-opacity: 1;
    border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-\\[rgba\\(22\\2c 163\\2c 74\\2c 0\\.35\\)\\] {
    border-color: rgba(22,163,74,0.35);
}
.border-\\[rgba\\(220\\2c 38\\2c 38\\2c 0\\.35\\)\\] {
    border-color: rgba(220,38,38,0.35);
}
.border-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.16\\)\\] {
    border-color: rgba(255,255,255,0.16);
}
.border-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.25\\)\\] {
    border-color: rgba(255,255,255,0.25);
}
.border-\\[var\\(--mk-line\\)\\] {
    border-color: var(--mk-line);
}
.border-danger {
    --tw-border-opacity: 1;
    border-color: rgb(220 38 38 / var(--tw-border-opacity, 1));
}
.border-faint {
    border-color: var(--muted);
}
.border-line {
    border-color: var(--border);
}
.border-primary {
    border-color: var(--primary);
}
.border-surface {
    border-color: var(--surface);
}
.border-transparent {
    border-color: transparent;
}
.border-warn {
    --tw-border-opacity: 1;
    border-color: rgb(217 119 6 / var(--tw-border-opacity, 1));
}
.border-b-primary {
    border-bottom-color: var(--primary);
}
.border-b-transparent {
    border-bottom-color: transparent;
}
.\\!bg-panel {
    background-color: var(--surface-2) !important;
}
.bg-\\[\\#0b1220\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(11 18 32 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f0f0f\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(15 15 15 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#151515\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(21 21 21 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#16a34a\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#17b26a\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(23 178 106 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#18181b\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(24 24 27 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1b1b1b\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(27 27 27 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#22c55e\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#3C87F7\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(60 135 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#4ade80\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6172f3\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(97 114 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#b45309\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d97706\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e2e8f0\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(226 232 240 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e6e9ef\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(230 233 239 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e9e9eb\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(233 233 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eaf2fe\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(234 242 254 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ecfdf3\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(236 253 243 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eff4ff\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(239 244 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#eff6ff\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f04438\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(240 68 56 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f0fdf4\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f1f2f5\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(241 242 245 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f59e0b\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f5f3ff\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f6f8fb\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(246 248 251 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f79009\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(247 144 9 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f87171\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fafbfd\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(250 251 253 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fef2f2\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fef3f2\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(254 243 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fefce8\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fffaeb\\] {
    --tw-bg-opacity: 1;
    background-color: rgb(255 250 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[color\\:var\\(--border\\)\\] {
    background-color: var(--border);
}
.bg-\\[color\\:var\\(--muted\\)\\] {
    background-color: var(--muted);
}
.bg-\\[color\\:var\\(--text\\)\\] {
    background-color: var(--text);
}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.22\\)\\] {
    background-color: rgba(0,0,0,0.22);
}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\] {
    background-color: rgba(0,0,0,0.45);
}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\] {
    background-color: rgba(0,0,0,0.5);
}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.55\\)\\] {
    background-color: rgba(0,0,0,0.55);
}
.bg-\\[rgba\\(15\\2c 23\\2c 42\\2c 0\\.45\\)\\] {
    background-color: rgba(15,23,42,0.45);
}
.bg-\\[rgba\\(217\\2c 119\\2c 6\\2c 0\\.1\\)\\] {
    background-color: rgba(217,119,6,0.1);
}
.bg-\\[rgba\\(217\\2c 119\\2c 6\\2c 0\\.12\\)\\] {
    background-color: rgba(217,119,6,0.12);
}
.bg-\\[rgba\\(22\\2c 163\\2c 74\\2c 0\\.12\\)\\] {
    background-color: rgba(22,163,74,0.12);
}
.bg-\\[rgba\\(220\\2c 38\\2c 38\\2c 0\\.12\\)\\] {
    background-color: rgba(220,38,38,0.12);
}
.bg-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.1\\)\\] {
    background-color: rgba(255,255,255,0.1);
}
.bg-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.82\\)\\] {
    background-color: rgba(255,255,255,0.82);
}
.bg-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.85\\)\\] {
    background-color: rgba(255,255,255,0.85);
}
.bg-\\[rgba\\(34\\2c 197\\2c 94\\2c 0\\.07\\)\\] {
    background-color: rgba(34,197,94,0.07);
}
.bg-\\[rgba\\(34\\2c 197\\2c 94\\2c 0\\.14\\)\\] {
    background-color: rgba(34,197,94,0.14);
}
.bg-\\[rgba\\(34\\2c 197\\2c 94\\2c 0\\.16\\)\\] {
    background-color: rgba(34,197,94,0.16);
}
.bg-\\[rgba\\(60\\2c 135\\2c 247\\2c 0\\.06\\)\\] {
    background-color: rgba(60,135,247,0.06);
}
.bg-\\[var\\(--mk-accent\\)\\] {
    background-color: var(--mk-accent);
}
.bg-\\[var\\(--mk-accent-tint\\)\\] {
    background-color: var(--mk-accent-tint);
}
.bg-bg {
    background-color: var(--bg);
}
.bg-danger {
    --tw-bg-opacity: 1;
    background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-dim {
    background-color: var(--text-sub);
}
.bg-faint {
    background-color: var(--muted);
}
.bg-good {
    --tw-bg-opacity: 1;
    background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-ink {
    background-color: var(--text);
}
.bg-line {
    background-color: var(--border);
}
.bg-panel {
    background-color: var(--surface-2);
}
.bg-primary {
    background-color: var(--primary);
}
.bg-primary-tint {
    background-color: var(--primary-tint);
}
.bg-surface {
    background-color: var(--surface);
}
.bg-transparent {
    background-color: transparent;
}
.bg-warn {
    --tw-bg-opacity: 1;
    background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/20 {
    background-color: rgb(255 255 255 / 0.2);
}
.bg-gradient-to-br {
    background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.from-\\[\\#eaf2fe\\] {
    --tw-gradient-from: #eaf2fe var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(234 242 254 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#eef2f7\\] {
    --tw-gradient-from: #eef2f7 var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(238 242 247 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[\\#dbe8ff\\] {
    --tw-gradient-to: #dbe8ff var(--tw-gradient-to-position);
}
.to-\\[\\#dfe6f0\\] {
    --tw-gradient-to: #dfe6f0 var(--tw-gradient-to-position);
}
.fill-faint {
    fill: var(--muted);
}
.stroke-line {
    stroke: var(--border);
}
.stroke-1 {
    stroke-width: 1;
}
.object-contain {
    -o-object-fit: contain;
       object-fit: contain;
}
.p-0 {
    padding: 0px;
}
.p-1 {
    padding: 0.25rem;
}
.p-1\\.5 {
    padding: 0.375rem;
}
.p-10 {
    padding: 2.5rem;
}
.p-2 {
    padding: 0.5rem;
}
.p-2\\.5 {
    padding: 0.625rem;
}
.p-3 {
    padding: 0.75rem;
}
.p-4 {
    padding: 1rem;
}
.p-5 {
    padding: 1.25rem;
}
.p-6 {
    padding: 1.5rem;
}
.p-7 {
    padding: 1.75rem;
}
.p-8 {
    padding: 2rem;
}
.p-\\[14px\\] {
    padding: 14px;
}
.p-\\[18px\\] {
    padding: 18px;
}
.p-\\[22px\\] {
    padding: 22px;
}
.p-\\[26px\\] {
    padding: 26px;
}
.p-\\[3px\\] {
    padding: 3px;
}
.\\!px-2\\.5 {
    padding-left: 0.625rem !important;
    padding-right: 0.625rem !important;
}
.\\!px-\\[14px\\] {
    padding-left: 14px !important;
    padding-right: 14px !important;
}
.\\!py-\\[12px\\] {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
}
.\\!py-\\[6px\\] {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
}
.\\!py-\\[7px\\] {
    padding-top: 7px !important;
    padding-bottom: 7px !important;
}
.px-0 {
    padding-left: 0px;
    padding-right: 0px;
}
.px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
}
.px-1\\.5 {
    padding-left: 0.375rem;
    padding-right: 0.375rem;
}
.px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}
.px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
}
.px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
}
.px-3\\.5 {
    padding-left: 0.875rem;
    padding-right: 0.875rem;
}
.px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
}
.px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
}
.px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
}
.px-\\[10px\\] {
    padding-left: 10px;
    padding-right: 10px;
}
.px-\\[11px\\] {
    padding-left: 11px;
    padding-right: 11px;
}
.px-\\[12px\\] {
    padding-left: 12px;
    padding-right: 12px;
}
.px-\\[13px\\] {
    padding-left: 13px;
    padding-right: 13px;
}
.px-\\[14px\\] {
    padding-left: 14px;
    padding-right: 14px;
}
.px-\\[16px\\] {
    padding-left: 16px;
    padding-right: 16px;
}
.px-\\[18px\\] {
    padding-left: 18px;
    padding-right: 18px;
}
.px-\\[22px\\] {
    padding-left: 22px;
    padding-right: 22px;
}
.px-\\[24px\\] {
    padding-left: 24px;
    padding-right: 24px;
}
.px-\\[26px\\] {
    padding-left: 26px;
    padding-right: 26px;
}
.px-\\[3px\\] {
    padding-left: 3px;
    padding-right: 3px;
}
.px-\\[44px\\] {
    padding-left: 44px;
    padding-right: 44px;
}
.px-\\[4px\\] {
    padding-left: 4px;
    padding-right: 4px;
}
.px-\\[5px\\] {
    padding-left: 5px;
    padding-right: 5px;
}
.px-\\[6px\\] {
    padding-left: 6px;
    padding-right: 6px;
}
.px-\\[7px\\] {
    padding-left: 7px;
    padding-right: 7px;
}
.px-\\[8px\\] {
    padding-left: 8px;
    padding-right: 8px;
}
.px-\\[9px\\] {
    padding-left: 9px;
    padding-right: 9px;
}
.py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
}
.py-0\\.5 {
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
}
.py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}
.py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
}
.py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
}
.py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
}
.py-14 {
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
}
.py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
}
.py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
}
.py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
}
.py-3\\.5 {
    padding-top: 0.875rem;
    padding-bottom: 0.875rem;
}
.py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
}
.py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
}
.py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}
.py-7 {
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
}
.py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
}
.py-\\[10px\\] {
    padding-top: 10px;
    padding-bottom: 10px;
}
.py-\\[11px\\] {
    padding-top: 11px;
    padding-bottom: 11px;
}
.py-\\[12px\\] {
    padding-top: 12px;
    padding-bottom: 12px;
}
.py-\\[13px\\] {
    padding-top: 13px;
    padding-bottom: 13px;
}
.py-\\[14px\\] {
    padding-top: 14px;
    padding-bottom: 14px;
}
.py-\\[15px\\] {
    padding-top: 15px;
    padding-bottom: 15px;
}
.py-\\[18px\\] {
    padding-top: 18px;
    padding-bottom: 18px;
}
.py-\\[1px\\] {
    padding-top: 1px;
    padding-bottom: 1px;
}
.py-\\[22px\\] {
    padding-top: 22px;
    padding-bottom: 22px;
}
.py-\\[2px\\] {
    padding-top: 2px;
    padding-bottom: 2px;
}
.py-\\[3px\\] {
    padding-top: 3px;
    padding-bottom: 3px;
}
.py-\\[4px\\] {
    padding-top: 4px;
    padding-bottom: 4px;
}
.py-\\[52px\\] {
    padding-top: 52px;
    padding-bottom: 52px;
}
.py-\\[56px\\] {
    padding-top: 56px;
    padding-bottom: 56px;
}
.py-\\[5px\\] {
    padding-top: 5px;
    padding-bottom: 5px;
}
.py-\\[60px\\] {
    padding-top: 60px;
    padding-bottom: 60px;
}
.py-\\[6px\\] {
    padding-top: 6px;
    padding-bottom: 6px;
}
.py-\\[7px\\] {
    padding-top: 7px;
    padding-bottom: 7px;
}
.py-\\[8px\\] {
    padding-top: 8px;
    padding-bottom: 8px;
}
.py-\\[9px\\] {
    padding-top: 9px;
    padding-bottom: 9px;
}
.py-px {
    padding-top: 1px;
    padding-bottom: 1px;
}
.pb-1 {
    padding-bottom: 0.25rem;
}
.pb-1\\.5 {
    padding-bottom: 0.375rem;
}
.pb-10 {
    padding-bottom: 2.5rem;
}
.pb-16 {
    padding-bottom: 4rem;
}
.pb-2 {
    padding-bottom: 0.5rem;
}
.pb-3 {
    padding-bottom: 0.75rem;
}
.pb-4 {
    padding-bottom: 1rem;
}
.pb-6 {
    padding-bottom: 1.5rem;
}
.pb-8 {
    padding-bottom: 2rem;
}
.pb-\\[10px\\] {
    padding-bottom: 10px;
}
.pb-\\[22px\\] {
    padding-bottom: 22px;
}
.pb-\\[2px\\] {
    padding-bottom: 2px;
}
.pb-\\[30px\\] {
    padding-bottom: 30px;
}
.pb-\\[40px\\] {
    padding-bottom: 40px;
}
.pb-\\[6px\\] {
    padding-bottom: 6px;
}
.pl-0 {
    padding-left: 0px;
}
.pl-1 {
    padding-left: 0.25rem;
}
.pl-2 {
    padding-left: 0.5rem;
}
.pl-2\\.5 {
    padding-left: 0.625rem;
}
.pl-3 {
    padding-left: 0.75rem;
}
.pl-4 {
    padding-left: 1rem;
}
.pl-5 {
    padding-left: 1.25rem;
}
.pl-\\[10px\\] {
    padding-left: 10px;
}
.pl-\\[18px\\] {
    padding-left: 18px;
}
.pl-\\[22px\\] {
    padding-left: 22px;
}
.pl-\\[30px\\] {
    padding-left: 30px;
}
.pl-\\[33px\\] {
    padding-left: 33px;
}
.pl-\\[5px\\] {
    padding-left: 5px;
}
.pl-\\[7\\%\\] {
    padding-left: 7%;
}
.pr-1 {
    padding-right: 0.25rem;
}
.pr-12 {
    padding-right: 3rem;
}
.pr-2 {
    padding-right: 0.5rem;
}
.pr-2\\.5 {
    padding-right: 0.625rem;
}
.pr-20 {
    padding-right: 5rem;
}
.pr-3 {
    padding-right: 0.75rem;
}
.pr-4 {
    padding-right: 1rem;
}
.pr-\\[4px\\] {
    padding-right: 4px;
}
.pr-\\[52px\\] {
    padding-right: 52px;
}
.pt-0 {
    padding-top: 0px;
}
.pt-0\\.5 {
    padding-top: 0.125rem;
}
.pt-1 {
    padding-top: 0.25rem;
}
.pt-1\\.5 {
    padding-top: 0.375rem;
}
.pt-10 {
    padding-top: 2.5rem;
}
.pt-2 {
    padding-top: 0.5rem;
}
.pt-2\\.5 {
    padding-top: 0.625rem;
}
.pt-3 {
    padding-top: 0.75rem;
}
.pt-4 {
    padding-top: 1rem;
}
.pt-6 {
    padding-top: 1.5rem;
}
.pt-\\[15px\\] {
    padding-top: 15px;
}
.pt-\\[19px\\] {
    padding-top: 19px;
}
.pt-\\[1px\\] {
    padding-top: 1px;
}
.pt-\\[22px\\] {
    padding-top: 22px;
}
.pt-\\[26px\\] {
    padding-top: 26px;
}
.pt-\\[48px\\] {
    padding-top: 48px;
}
.pt-\\[6px\\] {
    padding-top: 6px;
}
.pt-\\[6vh\\] {
    padding-top: 6vh;
}
.text-left {
    text-align: left;
}
.text-center {
    text-align: center;
}
.text-right {
    text-align: right;
}
.align-top {
    vertical-align: top;
}
.align-middle {
    vertical-align: middle;
}
.font-mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-serif {
    font-family: ui-serif, Georgia, Cambria, "Times New Roman", Times, serif;
}
.font-sora {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}
.\\!text-\\[13px\\] {
    font-size: 13px !important;
}
.text-\\[0\\.9em\\] {
    font-size: 0.9em;
}
.text-\\[10\\.5px\\] {
    font-size: 10.5px;
}
.text-\\[10px\\] {
    font-size: 10px;
}
.text-\\[11\\.5px\\] {
    font-size: 11.5px;
}
.text-\\[11px\\] {
    font-size: 11px;
}
.text-\\[12\\.5px\\] {
    font-size: 12.5px;
}
.text-\\[12px\\] {
    font-size: 12px;
}
.text-\\[13\\.5px\\] {
    font-size: 13.5px;
}
.text-\\[13px\\] {
    font-size: 13px;
}
.text-\\[14\\.5px\\] {
    font-size: 14.5px;
}
.text-\\[14px\\] {
    font-size: 14px;
}
.text-\\[15\\.5px\\] {
    font-size: 15.5px;
}
.text-\\[15px\\] {
    font-size: 15px;
}
.text-\\[16px\\] {
    font-size: 16px;
}
.text-\\[17px\\] {
    font-size: 17px;
}
.text-\\[18px\\] {
    font-size: 18px;
}
.text-\\[19px\\] {
    font-size: 19px;
}
.text-\\[20px\\] {
    font-size: 20px;
}
.text-\\[21px\\] {
    font-size: 21px;
}
.text-\\[22px\\] {
    font-size: 22px;
}
.text-\\[24px\\] {
    font-size: 24px;
}
.text-\\[26px\\] {
    font-size: 26px;
}
.text-\\[27px\\] {
    font-size: 27px;
}
.text-\\[28px\\] {
    font-size: 28px;
}
.text-\\[30px\\] {
    font-size: 30px;
}
.text-\\[34px\\] {
    font-size: 34px;
}
.text-\\[38px\\] {
    font-size: 38px;
}
.text-\\[40px\\] {
    font-size: 40px;
}
.text-\\[42px\\] {
    font-size: 42px;
}
.text-\\[9\\.5px\\] {
    font-size: 9.5px;
}
.text-\\[9px\\] {
    font-size: 9px;
}
.text-\\[clamp\\(19px\\2c 2\\.6vw\\2c 28px\\)\\] {
    font-size: clamp(19px, 2.6vw, 28px);
}
.text-\\[clamp\\(26px\\2c 4vw\\2c 44px\\)\\] {
    font-size: clamp(26px, 4vw, 44px);
}
.font-bold {
    font-weight: 700;
}
.font-medium {
    font-weight: 500;
}
.font-normal {
    font-weight: 400;
}
.font-semibold {
    font-weight: 600;
}
.uppercase {
    text-transform: uppercase;
}
.lowercase {
    text-transform: lowercase;
}
.capitalize {
    text-transform: capitalize;
}
.italic {
    font-style: italic;
}
.ordinal {
    --tw-ordinal: ordinal;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.tabular-nums {
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-\\[1\\.07\\] {
    line-height: 1.07;
}
.leading-\\[1\\.08\\] {
    line-height: 1.08;
}
.leading-\\[1\\.15\\] {
    line-height: 1.15;
}
.leading-\\[1\\.25\\] {
    line-height: 1.25;
}
.leading-\\[1\\.2\\] {
    line-height: 1.2;
}
.leading-\\[1\\.35\\] {
    line-height: 1.35;
}
.leading-\\[1\\.3\\] {
    line-height: 1.3;
}
.leading-\\[1\\.45\\] {
    line-height: 1.45;
}
.leading-\\[1\\.4\\] {
    line-height: 1.4;
}
.leading-\\[1\\.55\\] {
    line-height: 1.55;
}
.leading-\\[1\\.5\\] {
    line-height: 1.5;
}
.leading-\\[1\\.65\\] {
    line-height: 1.65;
}
.leading-\\[1\\.6\\] {
    line-height: 1.6;
}
.leading-\\[16px\\] {
    line-height: 16px;
}
.leading-none {
    line-height: 1;
}
.tracking-\\[-0\\.015em\\] {
    letter-spacing: -0.015em;
}
.tracking-\\[-0\\.01em\\] {
    letter-spacing: -0.01em;
}
.tracking-\\[-0\\.022em\\] {
    letter-spacing: -0.022em;
}
.tracking-\\[-0\\.02em\\] {
    letter-spacing: -0.02em;
}
.tracking-\\[-0\\.03em\\] {
    letter-spacing: -0.03em;
}
.tracking-\\[0\\.01em\\] {
    letter-spacing: 0.01em;
}
.tracking-\\[0\\.02em\\] {
    letter-spacing: 0.02em;
}
.tracking-\\[0\\.03em\\] {
    letter-spacing: 0.03em;
}
.tracking-\\[0\\.04em\\] {
    letter-spacing: 0.04em;
}
.tracking-\\[0\\.05em\\] {
    letter-spacing: 0.05em;
}
.tracking-\\[0\\.06em\\] {
    letter-spacing: 0.06em;
}
.tracking-\\[0\\.12em\\] {
    letter-spacing: 0.12em;
}
.tracking-\\[0\\.14em\\] {
    letter-spacing: 0.14em;
}
.tracking-\\[0\\.1em\\] {
    letter-spacing: 0.1em;
}
.tracking-\\[0\\.5px\\] {
    letter-spacing: 0.5px;
}
.tracking-normal {
    letter-spacing: 0em;
}
.\\!text-faint {
    color: var(--muted) !important;
}
.text-\\[\\#067647\\] {
    --tw-text-opacity: 1;
    color: rgb(6 118 71 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0b1220\\] {
    --tw-text-opacity: 1;
    color: rgb(11 18 32 / var(--tw-text-opacity, 1));
}
.text-\\[\\#0f172a\\] {
    --tw-text-opacity: 1;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}
.text-\\[\\#101010\\] {
    --tw-text-opacity: 1;
    color: rgb(16 16 16 / var(--tw-text-opacity, 1));
}
.text-\\[\\#15803d\\] {
    --tw-text-opacity: 1;
    color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-\\[\\#166534\\] {
    --tw-text-opacity: 1;
    color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-\\[\\#18181b\\] {
    --tw-text-opacity: 1;
    color: rgb(24 24 27 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1D68D9\\] {
    --tw-text-opacity: 1;
    color: rgb(29 104 217 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1c1917\\] {
    --tw-text-opacity: 1;
    color: rgb(28 25 23 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1d4ed8\\] {
    --tw-text-opacity: 1;
    color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-\\[\\#22c55e\\] {
    --tw-text-opacity: 1;
    color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-\\[\\#334155\\] {
    --tw-text-opacity: 1;
    color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3538cd\\] {
    --tw-text-opacity: 1;
    color: rgb(53 56 205 / var(--tw-text-opacity, 1));
}
.text-\\[\\#44403c\\] {
    --tw-text-opacity: 1;
    color: rgb(68 64 60 / var(--tw-text-opacity, 1));
}
.text-\\[\\#4ade80\\] {
    --tw-text-opacity: 1;
    color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5c5c5c\\] {
    --tw-text-opacity: 1;
    color: rgb(92 92 92 / var(--tw-text-opacity, 1));
}
.text-\\[\\#64748b\\] {
    --tw-text-opacity: 1;
    color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6b6b6b\\] {
    --tw-text-opacity: 1;
    color: rgb(107 107 107 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6d28d9\\] {
    --tw-text-opacity: 1;
    color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-\\[\\#78716c\\] {
    --tw-text-opacity: 1;
    color: rgb(120 113 108 / var(--tw-text-opacity, 1));
}
.text-\\[\\#8f8f8f\\] {
    --tw-text-opacity: 1;
    color: rgb(143 143 143 / var(--tw-text-opacity, 1));
}
.text-\\[\\#94a3b8\\] {
    --tw-text-opacity: 1;
    color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a16207\\] {
    --tw-text-opacity: 1;
    color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a8a29e\\] {
    --tw-text-opacity: 1;
    color: rgb(168 162 158 / var(--tw-text-opacity, 1));
}
.text-\\[\\#b42318\\] {
    --tw-text-opacity: 1;
    color: rgb(180 35 24 / var(--tw-text-opacity, 1));
}
.text-\\[\\#b45309\\] {
    --tw-text-opacity: 1;
    color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-\\[\\#b4bcca\\] {
    --tw-text-opacity: 1;
    color: rgb(180 188 202 / var(--tw-text-opacity, 1));
}
.text-\\[\\#b54708\\] {
    --tw-text-opacity: 1;
    color: rgb(181 71 8 / var(--tw-text-opacity, 1));
}
.text-\\[\\#b91c1c\\] {
    --tw-text-opacity: 1;
    color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-\\[\\#dc2626\\] {
    --tw-text-opacity: 1;
    color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-\\[\\#e6e9ef\\] {
    --tw-text-opacity: 1;
    color: rgb(230 233 239 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f5f5f5\\] {
    --tw-text-opacity: 1;
    color: rgb(245 245 245 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f87171\\] {
    --tw-text-opacity: 1;
    color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-\\[\\#fafafa\\] {
    --tw-text-opacity: 1;
    color: rgb(250 250 250 / var(--tw-text-opacity, 1));
}
.text-\\[\\#fbbf24\\] {
    --tw-text-opacity: 1;
    color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-\\[\\#fca5a5\\] {
    --tw-text-opacity: 1;
    color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.4\\)\\] {
    color: rgba(255,255,255,0.4);
}
.text-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.55\\)\\] {
    color: rgba(255,255,255,0.55);
}
.text-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.62\\)\\] {
    color: rgba(255,255,255,0.62);
}
.text-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.65\\)\\] {
    color: rgba(255,255,255,0.65);
}
.text-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.7\\)\\] {
    color: rgba(255,255,255,0.7);
}
.text-\\[var\\(--mk-accent-dark\\)\\] {
    color: var(--mk-accent-dark);
}
.text-\\[var\\(--mk-ink\\)\\] {
    color: var(--mk-ink);
}
.text-\\[var\\(--mk-ink-soft\\)\\] {
    color: var(--mk-ink-soft);
}
.text-\\[var\\(--mk-muted\\)\\] {
    color: var(--mk-muted);
}
.text-danger {
    --tw-text-opacity: 1;
    color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-dim {
    color: var(--text-sub);
}
.text-faint {
    color: var(--muted);
}
.text-good {
    --tw-text-opacity: 1;
    color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-ink {
    color: var(--text);
}
.text-primary {
    color: var(--primary);
}
.text-primary-dark {
    color: var(--primary-dark);
}
.text-surface {
    color: var(--surface);
}
.text-transparent {
    color: transparent;
}
.text-warn {
    --tw-text-opacity: 1;
    color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/75 {
    color: rgb(255 255 255 / 0.75);
}
.underline {
    text-decoration-line: underline;
}
.no-underline {
    text-decoration-line: none;
}
.decoration-dotted {
    text-decoration-style: dotted;
}
.underline-offset-2 {
    text-underline-offset: 2px;
}
.underline-offset-4 {
    text-underline-offset: 4px;
}
.underline-offset-\\[3px\\] {
    text-underline-offset: 3px;
}
.accent-\\[color\\:var\\(--primary\\)\\] {
    accent-color: var(--primary);
}
.accent-primary {
    accent-color: var(--primary);
}
.opacity-0 {
    opacity: 0;
}
.opacity-100 {
    opacity: 1;
}
.opacity-35 {
    opacity: 0.35;
}
.opacity-40 {
    opacity: 0.4;
}
.opacity-60 {
    opacity: 0.6;
}
.opacity-70 {
    opacity: 0.7;
}
.opacity-80 {
    opacity: 0.8;
}
.opacity-90 {
    opacity: 0.9;
}
.opacity-\\[0\\.06\\] {
    opacity: 0.06;
}
.opacity-\\[0\\.22\\] {
    opacity: 0.22;
}
.opacity-\\[0\\.45\\] {
    opacity: 0.45;
}
.shadow {
    --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[-24px_0_60px_-24px_rgba\\(2\\2c 6\\2c 23\\2c 0\\.3\\)\\] {
    --tw-shadow: -24px 0 60px -24px rgba(2,6,23,0.3);
    --tw-shadow-colored: -24px 0 60px -24px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_-4px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.28\\)\\] {
    --tw-shadow: 0 -4px 40px rgba(0,0,0,0.28);
    --tw-shadow-colored: 0 -4px 40px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)\\] {
    --tw-shadow: 0 0 40px rgba(0,0,0,0.35);
    --tw-shadow-colored: 0 0 40px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_8px_rgba\\(24\\2c 24\\2c 27\\2c 0\\.45\\)\\] {
    --tw-shadow: 0 0 8px rgba(24,24,27,0.45);
    --tw-shadow-colored: 0 0 8px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_32px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\] {
    --tw-shadow: 0 12px 32px rgba(0,0,0,0.25);
    --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_32px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\] {
    --tw-shadow: 0 12px 32px rgba(0,0,0,0.45);
    --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_32px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.16\\)\\] {
    --tw-shadow: 0 12px 32px rgba(15,23,42,0.16);
    --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_32px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.18\\)\\] {
    --tw-shadow: 0 12px 32px rgba(15,23,42,0.18);
    --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_32px_rgba\\(2\\2c 6\\2c 23\\2c 0\\.16\\)\\] {
    --tw-shadow: 0 12px 32px rgba(2,6,23,0.16);
    --tw-shadow-colored: 0 12px 32px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_40px_rgba\\(60\\2c 135\\2c 247\\2c 0\\.16\\)\\] {
    --tw-shadow: 0 12px 40px rgba(60,135,247,0.16);
    --tw-shadow-colored: 0 12px 40px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.22\\)\\] {
    --tw-shadow: 0 16px 40px rgba(0,0,0,0.22);
    --tw-shadow-colored: 0 16px 40px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.07\\)\\2c 0_8px_20px_-10px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)\\] {
    --tw-shadow: 0 1px 2px rgba(0,0,0,0.07),0 8px 20px -10px rgba(0,0,0,0.25);
    --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color), 0 8px 20px -10px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.04\\)\\2c 0_12px_28px_-16px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.22\\)\\] {
    --tw-shadow: 0 1px 2px rgba(15,23,42,0.04),0 12px 28px -16px rgba(15,23,42,0.22);
    --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color), 0 12px 28px -16px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\] {
    --tw-shadow: 0 1px 2px rgba(15,23,42,0.08);
    --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.09\\)\\] {
    --tw-shadow: 0 1px 2px rgba(15,23,42,0.09);
    --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_3px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.10\\)\\2c 0_0_0_3px_rgba\\(60\\2c 135\\2c 247\\2c 0\\.22\\)\\] {
    --tw-shadow: 0 1px 3px rgba(15,23,42,0.10),0 0 0 3px rgba(60,135,247,0.22);
    --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color), 0 0 0 3px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_44px_-26px_rgba\\(2\\2c 6\\2c 23\\2c 0\\.5\\)\\] {
    --tw-shadow: 0 20px 44px -26px rgba(2,6,23,0.5);
    --tw-shadow-colored: 0 20px 44px -26px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\] {
    --tw-shadow: 0 20px 50px rgba(15,23,42,0.08);
    --tw-shadow-colored: 0 20px 50px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.45\\)\\] {
    --tw-shadow: 0 24px 60px rgba(0,0,0,0.45);
    --tw-shadow-colored: 0 24px 60px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)\\] {
    --tw-shadow: 0 8px 24px rgba(0,0,0,0.35);
    --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[24px_0_60px_-24px_rgba\\(2\\2c 6\\2c 23\\2c 0\\.3\\)\\] {
    --tw-shadow: 24px 0 60px -24px rgba(2,6,23,0.3);
    --tw-shadow-colored: 24px 0 60px -24px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card {
    --tw-shadow: var(--shadow);
    --tw-shadow-colored: var(--shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
.outline {
    outline-style: solid;
}
.outline-white {
    outline-color: #fff;
}
.ring {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2 {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.blur {
    --tw-blur: blur(8px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[100px\\] {
    --tw-blur: blur(100px);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
    --tw-invert: invert(100%);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-\\[12px\\] {
    --tw-backdrop-blur: blur(12px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[6px\\] {
    --tw-backdrop-blur: blur(6px);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-saturate-\\[1\\.8\\] {
    --tw-backdrop-saturate: saturate(1.8);
    backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[background\\2c color\\2c border-color\\2c transform\\] {
    transition-property: background,color,border-color,transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[background-color\\2c color\\2c border-color\\2c transform\\] {
    transition-property: background-color,color,border-color,transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[border-color\\2c box-shadow\\2c transform\\] {
    transition-property: border-color,box-shadow,transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[border-color\\2c box-shadow\\] {
    transition-property: border-color,box-shadow;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[bottom\\] {
    transition-property: bottom;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[color\\2c background\\] {
    transition-property: color,background;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[color\\2c text-shadow\\] {
    transition-property: color,text-shadow;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[fill\\] {
    transition-property: fill;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[filter\\] {
    transition-property: filter;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[grid-template-rows\\] {
    transition-property: grid-template-rows;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[opacity\\2c background-color\\2c border-color\\2c box-shadow\\] {
    transition-property: opacity,background-color,border-color,box-shadow;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[opacity\\2c transform\\] {
    transition-property: opacity,transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[transform\\2c height\\2c opacity\\] {
    transition-property: transform,height,opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[transform\\2c opacity\\] {
    transition-property: transform,opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[transform\\2c width\\2c height\\] {
    transition-property: transform,width,height;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[transform\\2c width\\] {
    transition-property: transform,width;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[width\\2c opacity\\] {
    transition-property: width,opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-\\[width\\] {
    transition-property: width;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-colors {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-opacity {
    transition-property: opacity;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-shadow {
    transition-property: box-shadow;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.transition-transform {
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}
.delay-100 {
    transition-delay: 100ms;
}
.duration-100 {
    transition-duration: 100ms;
}
.duration-150 {
    transition-duration: 150ms;
}
.duration-200 {
    transition-duration: 200ms;
}
.duration-300 {
    transition-duration: 300ms;
}
.duration-500 {
    transition-duration: 500ms;
}
.duration-\\[120ms\\] {
    transition-duration: 120ms;
}
.duration-\\[180ms\\] {
    transition-duration: 180ms;
}
.duration-\\[220ms\\] {
    transition-duration: 220ms;
}
.duration-\\[240ms\\] {
    transition-duration: 240ms;
}
.duration-\\[420ms\\] {
    transition-duration: 420ms;
}
.duration-\\[800ms\\] {
    transition-duration: 800ms;
}
.ease-\\[cubic-bezier\\(0\\.16\\2c 1\\2c 0\\.3\\2c 1\\)\\] {
    transition-timing-function: cubic-bezier(0.16,1,0.3,1);
}
.ease-\\[cubic-bezier\\(0\\.32\\2c 0\\.72\\2c 0\\.24\\2c 1\\)\\] {
    transition-timing-function: cubic-bezier(0.32,0.72,0.24,1);
}
.ease-out {
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.will-change-\\[opacity\\2c transform\\] {
    will-change: opacity,transform;
}
.will-change-transform {
    will-change: transform;
}
.\\[--sidebar-w\\:264px\\] {
    --sidebar-w: 264px;
}
.\\[-webkit-box-orient\\:vertical\\] {
    -webkit-box-orient: vertical;
}
.\\[-webkit-line-clamp\\:2\\] {
    -webkit-line-clamp: 2;
}
.\\[animation-duration\\:0\\.8s\\] {
    animation-duration: 0.8s;
}
.\\[border-bottom\\:1px_solid_var\\(--border\\)\\] {
    border-bottom: 1px solid var(--border);
}
.\\[border-bottom\\:1px_solid_var\\(--table-line\\)\\] {
    border-bottom: 1px solid var(--table-line);
}
.\\[border-left\\:1px_solid_var\\(--border\\)\\] {
    border-left: 1px solid var(--border);
}
.\\[border-left\\:1px_solid_var\\(--table-line\\)\\] {
    border-left: 1px solid var(--table-line);
}
.\\[border-left\\:2px_dotted_var\\(--border\\)\\] {
    border-left: 2px dotted var(--border);
}
.\\[border-left\\:2px_solid_var\\(--border\\)\\] {
    border-left: 2px solid var(--border);
}
.\\[border-right\\:1px_solid_\\#1d1d1d\\] {
    border-right: 1px solid #1d1d1d;
}
.\\[border-right\\:1px_solid_var\\(--border\\)\\] {
    border-right: 1px solid var(--border);
}
.\\[border-right\\:1px_solid_var\\(--table-line\\)\\] {
    border-right: 1px solid var(--table-line);
}
.\\[border-top-color\\:transparent\\] {
    border-top-color: transparent;
}
.\\[border-top-color\\:var\\(--primary\\)\\] {
    border-top-color: var(--primary);
}
.\\[border-top\\:1px_solid_rgba\\(15\\2c 23\\2c 42\\2c 0\\.06\\)\\] {
    border-top: 1px solid rgba(15,23,42,0.06);
}
.\\[border-top\\:1px_solid_var\\(--border\\)\\] {
    border-top: 1px solid var(--border);
}
.\\[border-top\\:1px_solid_var\\(--table-line\\)\\] {
    border-top: 1px solid var(--table-line);
}
.\\[border\\:0_solid_transparent\\] {
    border: 0 solid transparent;
}
.\\[border\\:1\\.5px_solid_currentColor\\] {
    border: 1.5px solid currentColor;
}
.\\[border\\:1\\.5px_solid_var\\(--primary\\)\\] {
    border: 1.5px solid var(--primary);
}
.\\[border\\:1px_dashed_var\\(--border\\)\\] {
    border: 1px dashed var(--border);
}
.\\[border\\:1px_dashed_var\\(--table-line\\)\\] {
    border: 1px dashed var(--table-line);
}
.\\[border\\:1px_solid_\\#262626\\] {
    border: 1px solid #262626;
}
.\\[border\\:1px_solid_\\#dc2626\\] {
    border: 1px solid #dc2626;
}
.\\[border\\:1px_solid_\\#dcdce0\\] {
    border: 1px solid #dcdce0;
}
.\\[border\\:1px_solid_\\#fecaca\\] {
    border: 1px solid #fecaca;
}
.\\[border\\:1px_solid_currentColor\\] {
    border: 1px solid currentColor;
}
.\\[border\\:1px_solid_rgba\\(34\\2c 197\\2c 94\\2c 0\\.35\\)\\] {
    border: 1px solid rgba(34,197,94,0.35);
}
.\\[border\\:1px_solid_var\\(--border\\)\\] {
    border: 1px solid var(--border);
}
.\\[border\\:1px_solid_var\\(--primary\\)\\] {
    border: 1px solid var(--primary);
}
.\\[border\\:1px_solid_var\\(--table-line\\)\\] {
    border: 1px solid var(--table-line);
}
.\\[border\\:2px_solid_rgba\\(255\\2c 255\\2c 255\\2c 0\\.18\\)\\] {
    border: 2px solid rgba(255,255,255,0.18);
}
.\\[border\\:2px_solid_var\\(--table-line\\)\\] {
    border: 2px solid var(--table-line);
}
.\\[border\\:none\\] {
    border: none;
}
.\\[bottom\\:calc\\(20px\\+var\\(--compose-dock-h\\2c 0px\\)\\)\\] {
    bottom: calc(20px + var(--compose-dock-h,0px));
}
.\\[display\\:-webkit-box\\] {
    display: -webkit-box;
}
.\\[filter\\:drop-shadow\\(0_30px_60px_rgba\\(2\\2c 6\\2c 23\\2c 0\\.14\\)\\)\\] {
    filter: drop-shadow(0 30px 60px rgba(2,6,23,0.14));
}
.\\[perspective\\:1800px\\] {
    perspective: 1800px;
}
.\\[scrollbar-width\\:none\\] {
    scrollbar-width: none;
}
.\\[stroke-dasharray\\:3_3\\] {
    stroke-dasharray: 3 3;
}
.\\[text-shadow\\:0_0_10px_rgba\\(24\\2c 24\\2c 27\\2c 0\\.28\\)\\] {
    text-shadow: 0 0 10px rgba(24,24,27,0.28);
}
.\\[transform-box\\:fill-box\\] {
    transform-box: fill-box;
}
.\\[transform-origin\\:bottom\\] {
    transform-origin: bottom;
}
.\\[transform\\:rotateY\\(24deg\\)_rotateX\\(6deg\\)_rotateZ\\(-3deg\\)\\] {
    transform: rotateY(24deg) rotateX(6deg) rotateZ(-3deg);
}

/* Preflight is disabled (the legacy styles.css still styles unconverted pages),
   so native form-control chrome — the 2px "outset" button border, the native
   search-field look — leaks through on Tailwind-migrated components. Re-add just
   the control normalization preflight would provide. Kept in @layer base so it
   sits below utilities and below the unlayered styles.css, meaning any element
   that sets its own border (legacy .btn-ghost, .search, .region-select select,
   or a Tailwind \`border\` utility) still wins. */

.placeholder\\:text-\\[\\#565656\\]::-moz-placeholder {
    --tw-text-opacity: 1;
    color: rgb(86 86 86 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-\\[\\#565656\\]::placeholder {
    --tw-text-opacity: 1;
    color: rgb(86 86 86 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-faint::-moz-placeholder {
    color: var(--muted);
}

.placeholder\\:text-faint::placeholder {
    color: var(--muted);
}

.before\\:absolute::before {
    content: var(--tw-content);
    position: absolute;
}

.before\\:bottom-\\[2px\\]::before {
    content: var(--tw-content);
    bottom: 2px;
}

.before\\:left-\\[19px\\]::before {
    content: var(--tw-content);
    left: 19px;
}

.before\\:top-\\[2px\\]::before {
    content: var(--tw-content);
    top: 2px;
}

.before\\:w-px::before {
    content: var(--tw-content);
    width: 1px;
}

.before\\:bg-\\[\\#e2e2e5\\]::before {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(226 226 229 / var(--tw-bg-opacity, 1));
}

.before\\:content-\\[\\'\\'\\]::before {
    --tw-content: '';
    content: var(--tw-content);
}

.first\\:ml-0:first-child {
    margin-left: 0px;
}

.first\\:mt-0:first-child {
    margin-top: 0px;
}

.first\\:mt-1:first-child {
    margin-top: 0.25rem;
}

.first\\:border-t-0:first-child {
    border-top-width: 0px;
}

.last\\:mb-0:last-child {
    margin-bottom: 0px;
}

.last\\:border-b-0:last-child {
    border-bottom-width: 0px;
}

.last\\:\\[border-bottom\\:none\\]:last-child {
    border-bottom: none;
}

.first-of-type\\:mt-10:first-of-type {
    margin-top: 2.5rem;
}

.first-of-type\\:border-t-0:first-of-type {
    border-top-width: 0px;
}

.focus-within\\:border-primary:focus-within {
    border-color: var(--primary);
}

.focus-within\\:opacity-100:focus-within {
    opacity: 1;
}

.focus-within\\:shadow-\\[0_0_0_3px_rgba\\(60\\2c 135\\2c 247\\2c 0\\.2\\)\\]:focus-within {
    --tw-shadow: 0 0 0 3px rgba(60,135,247,0.2);
    --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus-within\\:\\[border-color\\:\\#3f3f3f\\]:focus-within {
    border-color: #3f3f3f;
}

.focus-within\\:\\[border-color\\:var\\(--primary\\)\\]:focus-within {
    border-color: var(--primary);
}

.hover\\:-translate-y-\\[2px\\]:hover {
    --tw-translate-y: -2px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-\\[\\#b4bcca\\]:hover {
    --tw-border-opacity: 1;
    border-color: rgb(180 188 202 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[var\\(--mk-ghost\\)\\]:hover {
    border-color: var(--mk-ghost);
}

.hover\\:border-faint:hover {
    border-color: var(--muted);
}

.hover\\:border-primary:hover {
    border-color: var(--primary);
}

.hover\\:bg-\\[\\#1D68D9\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(29 104 217 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1e293b\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(30 41 59 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#e6e7ec\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(230 231 236 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#e9e9e9\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(233 233 233 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#f6f8fb\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(246 248 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#fafbfd\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(250 251 253 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#fef2f2\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.03\\)\\]:hover {
    background-color: rgba(255,255,255,0.03);
}

.hover\\:bg-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.04\\)\\]:hover {
    background-color: rgba(255,255,255,0.04);
}

.hover\\:bg-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.1\\)\\]:hover {
    background-color: rgba(255,255,255,0.1);
}

.hover\\:bg-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.12\\)\\]:hover {
    background-color: rgba(255,255,255,0.12);
}

.hover\\:bg-\\[rgba\\(255\\2c 255\\2c 255\\2c 0\\.9\\)\\]:hover {
    background-color: rgba(255,255,255,0.9);
}

.hover\\:bg-\\[var\\(--mk-accent-dark\\)\\]:hover {
    background-color: var(--mk-accent-dark);
}

.hover\\:bg-\\[var\\(--mk-surface-soft\\)\\]:hover {
    background-color: var(--mk-surface-soft);
}

.hover\\:bg-panel:hover {
    background-color: var(--surface-2);
}

.hover\\:bg-primary-dark:hover {
    background-color: var(--primary-dark);
}

.hover\\:bg-primary-tint:hover {
    background-color: var(--primary-tint);
}

.hover\\:bg-surface:hover {
    background-color: var(--surface);
}

.hover\\:bg-white\\/30:hover {
    background-color: rgb(255 255 255 / 0.3);
}

.hover\\:text-\\[\\#0f172a\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#44403c\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(68 64 60 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#57534e\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(87 83 78 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#78716c\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(120 113 108 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#cfcfcf\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(207 207 207 / var(--tw-text-opacity, 1));
}

.hover\\:text-\\[\\#dc2626\\]:hover {
    --tw-text-opacity: 1;
    color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.hover\\:text-danger:hover {
    --tw-text-opacity: 1;
    color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.hover\\:text-dim:hover {
    color: var(--text-sub);
}

.hover\\:text-ink:hover {
    color: var(--text);
}

.hover\\:text-primary:hover {
    color: var(--primary);
}

.hover\\:text-primary-dark:hover {
    color: var(--primary-dark);
}

.hover\\:text-white:hover {
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
    text-decoration-line: underline;
}

.hover\\:opacity-80:hover {
    opacity: 0.8;
}

.hover\\:shadow-\\[0_4px_14px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.08\\)\\]:hover {
    --tw-shadow: 0 4px 14px rgba(15,23,42,0.08);
    --tw-shadow-colored: 0 4px 14px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_6px_20px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.05\\)\\]:hover {
    --tw-shadow: 0 6px 20px rgba(15,23,42,0.05);
    --tw-shadow-colored: 0 6px 20px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-\\[0_8px_30px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.06\\)\\]:hover {
    --tw-shadow: 0 8px 30px rgba(15,23,42,0.06);
    --tw-shadow-colored: 0 8px 30px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:brightness-110:hover {
    --tw-brightness: brightness(1.1);
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.hover\\:\\[border-color\\:var\\(--muted\\)\\]:hover {
    border-color: var(--muted);
}

.hover\\:\\[border-color\\:var\\(--primary\\)\\]:hover {
    border-color: var(--primary);
}

.focus\\:border-primary:focus {
    border-color: var(--primary);
}

.focus\\:opacity-100:focus {
    opacity: 1;
}

.focus\\:shadow-\\[0_0_0_3px_rgba\\(60\\2c 135\\2c 247\\2c 0\\.2\\)\\]:focus {
    --tw-shadow: 0 0 0 3px rgba(60,135,247,0.2);
    --tw-shadow-colored: 0 0 0 3px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
}

.focus-visible\\:ring-2:focus-visible {
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:\\[outline-offset\\:3px\\]:focus-visible {
    outline-offset: 3px;
}

.focus-visible\\:\\[outline\\:2px_solid_var\\(--primary\\)\\]:focus-visible {
    outline: 2px solid var(--primary);
}

.focus-visible\\:\\[outline\\:2px_solid_var\\(--text\\)\\]:focus-visible {
    outline: 2px solid var(--text);
}

.active\\:translate-y-\\[1px\\]:active {
    --tw-translate-y: 1px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:translate-y-px:active {
    --tw-translate-y: 1px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:cursor-grabbing:active {
    cursor: grabbing;
}

.enabled\\:cursor-pointer:enabled {
    cursor: pointer;
}

.enabled\\:hover\\:bg-panel:hover:enabled {
    background-color: var(--surface-2);
}

.enabled\\:hover\\:bg-primary-dark:hover:enabled {
    background-color: var(--primary-dark);
}

.enabled\\:hover\\:\\[border-color\\:var\\(--primary\\)\\]:hover:enabled {
    border-color: var(--primary);
}

.disabled\\:cursor-not-allowed:disabled {
    cursor: not-allowed;
}

.disabled\\:opacity-35:disabled {
    opacity: 0.35;
}

.disabled\\:opacity-40:disabled {
    opacity: 0.4;
}

.disabled\\:opacity-45:disabled {
    opacity: 0.45;
}

.disabled\\:opacity-50:disabled {
    opacity: 0.5;
}

.disabled\\:opacity-60:disabled {
    opacity: 0.6;
}

.disabled\\:opacity-70:disabled {
    opacity: 0.7;
}

.disabled\\:opacity-\\[0\\.45\\]:disabled {
    opacity: 0.45;
}

.group[open] .group-open\\:rotate-90 {
    --tw-rotate: 90deg;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:focus-within .group-focus-within\\:opacity-100 {
    opacity: 1;
}

.group:hover .group-hover\\:translate-x-0\\.5 {
    --tw-translate-x: 0.125rem;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group\\/resize:hover .group-hover\\/resize\\:bg-primary {
    background-color: var(--primary);
}

.group:hover .group-hover\\:bg-panel {
    background-color: var(--surface-2);
}

.group:hover .group-hover\\:text-primary {
    color: var(--primary);
}

.group\\/th:hover .group-hover\\/th\\:opacity-100 {
    opacity: 1;
}

.group:hover .group-hover\\:opacity-100 {
    opacity: 1;
}

.group:hover .group-hover\\:\\[animation\\:marqueeTitle_2500ms_ease-in-out_infinite_alternate\\] {
    animation: marqueeTitle 2500ms ease-in-out infinite alternate;
}

.group\\/resize:focus .group-focus\\/resize\\:bg-primary {
    background-color: var(--primary);
}

.group.sidebar-collapsed .group-\\[\\.sidebar-collapsed\\]\\:mt-2 {
    margin-top: 0.5rem;
}

.group.sidebar-collapsed .group-\\[\\.sidebar-collapsed\\]\\:hidden {
    display: none;
}

.group.sidebar-collapsed .group-\\[\\.sidebar-collapsed\\]\\:grid-rows-\\[1fr\\] {
    grid-template-rows: 1fr;
}

.group.sidebar-collapsed .group-\\[\\.sidebar-collapsed\\]\\:justify-center {
    justify-content: center;
}

.group.sidebar-collapsed .group-\\[\\.sidebar-collapsed\\]\\:gap-x-0 {
    -moz-column-gap: 0px;
         column-gap: 0px;
}

.group.sidebar-collapsed .group-\\[\\.sidebar-collapsed\\]\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
}

.group.sidebar-collapsed .group-\\[\\.sidebar-collapsed\\]\\:px-\\[10px\\] {
    padding-left: 10px;
    padding-right: 10px;
}

.group.sidebar-collapsed .group-\\[\\.sidebar-collapsed\\]\\:opacity-100 {
    opacity: 1;
}

.group.sidebar-collapsed .group-\\[\\.sidebar-collapsed\\]\\:transition-none {
    transition-property: none;
}

.has-\\[\\.sidebar-collapsed\\]\\:\\[--sidebar-w\\:68px\\]:has(.sidebar-collapsed) {
    --sidebar-w: 68px;
}

@media (prefers-reduced-motion: reduce) {
    .motion-reduce\\:translate-y-0 {
        --tw-translate-y: 0px;
        transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    }
    .motion-reduce\\:animate-none {
        animation: none;
    }
    .motion-reduce\\:opacity-100 {
        opacity: 1;
    }
    .motion-reduce\\:transition-none {
        transition-property: none;
    }
    .group:hover .motion-reduce\\:group-hover\\:\\[animation\\:none\\] {
        animation: none;
    }
}

@media (max-width: 1100px) {
    .max-\\[1100px\\]\\:grid-cols-1 {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
}

@media (max-width: 900px) {
    .max-\\[900px\\]\\:inline-flex {
        display: inline-flex;
    }
    .max-\\[900px\\]\\:hidden {
        display: none;
    }
}

@media (max-width: 860px) {
    .max-\\[860px\\]\\:w-\\[208px\\] {
        width: 208px;
    }
    .max-\\[860px\\]\\:\\[--sidebar-w\\:220px\\] {
        --sidebar-w: 220px;
    }
}

@media not all and (min-width: 768px) {
    .max-md\\:mt-6 {
        margin-top: 1.5rem;
    }
    .max-md\\:grid {
        display: grid;
    }
    .max-md\\:hidden {
        display: none;
    }
    .max-md\\:flex-wrap {
        flex-wrap: wrap;
    }
    .max-md\\:gap-x-6 {
        -moz-column-gap: 1.5rem;
             column-gap: 1.5rem;
    }
    .max-md\\:overflow-x-auto {
        overflow-x: auto;
    }
    .max-md\\:rounded-none {
        border-radius: 0px;
    }
    .max-md\\:border-0 {
        border-width: 0px;
    }
    .max-md\\:p-0 {
        padding: 0px;
    }
    .max-md\\:p-3 {
        padding: 0.75rem;
    }
    .max-md\\:p-4 {
        padding: 1rem;
    }
    .max-md\\:px-3 {
        padding-left: 0.75rem;
        padding-right: 0.75rem;
    }
    .max-md\\:px-4 {
        padding-left: 1rem;
        padding-right: 1rem;
    }
    .max-md\\:py-4 {
        padding-top: 1rem;
        padding-bottom: 1rem;
    }
    .max-md\\:pb-6 {
        padding-bottom: 1.5rem;
    }
    .max-md\\:pt-4 {
        padding-top: 1rem;
    }
    .max-md\\:text-\\[20px\\] {
        font-size: 20px;
    }
    .max-md\\:\\[scrollbar-width\\:none\\] {
        scrollbar-width: none;
    }
}

@media (max-width: 760px) {
    .max-\\[760px\\]\\:hidden {
        display: none;
    }
    .max-\\[760px\\]\\:grid-cols-1 {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
}

@media (max-width: 720px) {
    .max-\\[720px\\]\\:hidden {
        display: none;
    }
    .max-\\[720px\\]\\:grid-cols-1 {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
    .max-\\[720px\\]\\:grid-cols-\\[1fr_150px\\] {
        grid-template-columns: 1fr 150px;
    }
    .max-\\[720px\\]\\:text-\\[16px\\] {
        font-size: 16px;
    }
    .max-\\[720px\\]\\:text-\\[22px\\] {
        font-size: 22px;
    }
    .max-\\[720px\\]\\:text-\\[30px\\] {
        font-size: 30px;
    }
}

@media not all and (min-width: 640px) {
    .max-sm\\:hidden {
        display: none;
    }
}

@media (max-width: 640px) {
    .max-\\[640px\\]\\:hidden {
        display: none;
    }
    .max-\\[640px\\]\\:grid-cols-1 {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
    .max-\\[640px\\]\\:gap-y-1\\.5 {
        row-gap: 0.375rem;
    }
    .max-\\[640px\\]\\:gap-y-3 {
        row-gap: 0.75rem;
    }
}

@media (max-width: 560px) {
    .max-\\[560px\\]\\:hidden {
        display: none;
    }
    .max-\\[560px\\]\\:grid-cols-1 {
        grid-template-columns: repeat(1, minmax(0, 1fr));
    }
    .max-\\[560px\\]\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .max-\\[560px\\]\\:grid-cols-\\[1fr\\] {
        grid-template-columns: 1fr;
    }
}

@media (min-width: 640px) {
    .sm\\:block {
        display: block;
    }
    .sm\\:inline {
        display: inline;
    }
    .sm\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .sm\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .sm\\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .sm\\:flex-row {
        flex-direction: row;
    }
    .sm\\:items-center {
        align-items: center;
    }
    .sm\\:px-6 {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }
    .sm\\:px-8 {
        padding-left: 2rem;
        padding-right: 2rem;
    }
    .sm\\:py-\\[72px\\] {
        padding-top: 72px;
        padding-bottom: 72px;
    }
    .sm\\:py-\\[88px\\] {
        padding-top: 88px;
        padding-bottom: 88px;
    }
    .sm\\:text-\\[40px\\] {
        font-size: 40px;
    }
}

@media (min-width: 720px) {
    .min-\\[720px\\]\\:sticky {
        position: sticky;
    }
    .min-\\[720px\\]\\:top-\\[90px\\] {
        top: 90px;
    }
    .min-\\[720px\\]\\:grid-cols-\\[160px_1fr\\] {
        grid-template-columns: 160px 1fr;
    }
    .min-\\[720px\\]\\:gap-7 {
        gap: 1.75rem;
    }
    .min-\\[720px\\]\\:border-l {
        border-left-width: 1px;
    }
    .min-\\[720px\\]\\:border-\\[\\#e6e9ef\\] {
        --tw-border-opacity: 1;
        border-color: rgb(230 233 239 / var(--tw-border-opacity, 1));
    }
    .min-\\[720px\\]\\:pl-7 {
        padding-left: 1.75rem;
    }
    .min-\\[720px\\]\\:pt-\\[72px\\] {
        padding-top: 72px;
    }
    .min-\\[720px\\]\\:text-\\[18px\\] {
        font-size: 18px;
    }
    .min-\\[720px\\]\\:text-\\[26px\\] {
        font-size: 26px;
    }
    .min-\\[720px\\]\\:text-\\[42px\\] {
        font-size: 42px;
    }
    .min-\\[720px\\]\\:text-\\[54px\\] {
        font-size: 54px;
    }
    .min-\\[720px\\]\\:before\\:absolute::before {
        content: var(--tw-content);
        position: absolute;
    }
    .min-\\[720px\\]\\:before\\:left-\\[-5px\\]::before {
        content: var(--tw-content);
        left: -5px;
    }
    .min-\\[720px\\]\\:before\\:top-\\[6px\\]::before {
        content: var(--tw-content);
        top: 6px;
    }
    .min-\\[720px\\]\\:before\\:h-\\[9px\\]::before {
        content: var(--tw-content);
        height: 9px;
    }
    .min-\\[720px\\]\\:before\\:w-\\[9px\\]::before {
        content: var(--tw-content);
        width: 9px;
    }
    .min-\\[720px\\]\\:before\\:rounded-full::before {
        content: var(--tw-content);
        border-radius: 9999px;
    }
    .min-\\[720px\\]\\:before\\:bg-\\[\\#3C87F7\\]::before {
        content: var(--tw-content);
        --tw-bg-opacity: 1;
        background-color: rgb(60 135 247 / var(--tw-bg-opacity, 1));
    }
    .min-\\[720px\\]\\:before\\:shadow-\\[0_0_0_4px_\\#fff\\]::before {
        content: var(--tw-content);
        --tw-shadow: 0 0 0 4px #fff;
        --tw-shadow-colored: 0 0 0 4px var(--tw-shadow-color);
        box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    }
    .min-\\[720px\\]\\:before\\:content-\\[\\'\\'\\]::before {
        --tw-content: '';
        content: var(--tw-content);
    }
}

@media (min-width: 721px) {
    .min-\\[721px\\]\\:grid-cols-\\[220px_1fr_64px\\] {
        grid-template-columns: 220px 1fr 64px;
    }
}

@media (min-width: 768px) {
    .md\\:hidden {
        display: none;
    }
    .md\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .md\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .md\\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
}

@media (min-width: 900px) {
    .min-\\[900px\\]\\:block {
        display: block;
    }
}

@media (min-width: 960px) {
    .min-\\[960px\\]\\:order-2 {
        order: 2;
    }
    .min-\\[960px\\]\\:col-auto {
        grid-column: auto;
    }
    .min-\\[960px\\]\\:flex {
        display: flex;
    }
    .min-\\[960px\\]\\:grid-cols-2 {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    .min-\\[960px\\]\\:grid-cols-3 {
        grid-template-columns: repeat(3, minmax(0, 1fr));
    }
    .min-\\[960px\\]\\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .min-\\[960px\\]\\:grid-cols-\\[1\\.5fr_repeat\\(4\\2c 1fr\\)\\] {
        grid-template-columns: 1.5fr repeat(4,1fr);
    }
    .min-\\[960px\\]\\:grid-cols-\\[220px_1fr\\] {
        grid-template-columns: 220px 1fr;
    }
    .min-\\[960px\\]\\:gap-14 {
        gap: 3.5rem;
    }
    .min-\\[960px\\]\\:gap-16 {
        gap: 4rem;
    }
}

@media (min-width: 1024px) {
    .lg\\:flex {
        display: flex;
    }
    .lg\\:h-auto {
        height: auto;
    }
    .lg\\:max-h-none {
        max-height: none;
    }
    .lg\\:w-\\[34\\%\\] {
        width: 34%;
    }
    .lg\\:w-\\[344px\\] {
        width: 344px;
    }
    .lg\\:min-w-\\[340px\\] {
        min-width: 340px;
    }
    .lg\\:max-w-\\[520px\\] {
        max-width: 520px;
    }
    .lg\\:flex-none {
        flex: none;
    }
    .lg\\:grid-cols-4 {
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
    .lg\\:grid-cols-\\[1\\.55fr_1fr\\] {
        grid-template-columns: 1.55fr 1fr;
    }
    .lg\\:grid-cols-\\[330px_1fr\\] {
        grid-template-columns: 330px 1fr;
    }
    .lg\\:flex-row {
        flex-direction: row;
    }
}

.dark\\:block:where([data-theme="dark"], [data-theme="dark"] *) {
    display: block;
}

.dark\\:hidden:where([data-theme="dark"], [data-theme="dark"] *) {
    display: none;
}

.dark\\:border-\\[rgba\\(161\\2c 98\\2c 7\\2c 0\\.4\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    border-color: rgba(161,98,7,0.4);
}

.dark\\:border-\\[rgba\\(22\\2c 163\\2c 74\\2c 0\\.4\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    border-color: rgba(22,163,74,0.4);
}

.dark\\:border-\\[rgba\\(220\\2c 38\\2c 38\\2c 0\\.35\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    border-color: rgba(220,38,38,0.35);
}

.dark\\:border-\\[rgba\\(220\\2c 38\\2c 38\\2c 0\\.4\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    border-color: rgba(220,38,38,0.4);
}

.dark\\:border-\\[rgba\\(34\\2c 197\\2c 94\\2c 0\\.35\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    border-color: rgba(34,197,94,0.35);
}

.dark\\:border-line:where([data-theme="dark"], [data-theme="dark"] *) {
    border-color: var(--border);
}

.dark\\:bg-\\[\\#0a0a0a\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-bg-opacity: 1;
    background-color: rgb(10 10 10 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#242424\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-bg-opacity: 1;
    background-color: rgb(36 36 36 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#283446\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-bg-opacity: 1;
    background-color: rgb(40 52 70 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#3a3a3c\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-bg-opacity: 1;
    background-color: rgb(58 58 60 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#f5f5f5\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-bg-opacity: 1;
    background-color: rgb(245 245 245 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.6\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(0,0,0,0.6);
}

.dark\\:bg-\\[rgba\\(109\\2c 40\\2c 217\\2c 0\\.22\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(109,40,217,0.22);
}

.dark\\:bg-\\[rgba\\(161\\2c 98\\2c 7\\2c 0\\.14\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(161,98,7,0.14);
}

.dark\\:bg-\\[rgba\\(161\\2c 98\\2c 7\\2c 0\\.18\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(161,98,7,0.18);
}

.dark\\:bg-\\[rgba\\(161\\2c 98\\2c 7\\2c 0\\.2\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(161,98,7,0.2);
}

.dark\\:bg-\\[rgba\\(185\\2c 28\\2c 28\\2c 0\\.2\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(185,28,28,0.2);
}

.dark\\:bg-\\[rgba\\(21\\2c 128\\2c 61\\2c 0\\.18\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(21,128,61,0.18);
}

.dark\\:bg-\\[rgba\\(21\\2c 21\\2c 21\\2c 0\\.85\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(21,21,21,0.85);
}

.dark\\:bg-\\[rgba\\(217\\2c 119\\2c 6\\2c 0\\.22\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(217,119,6,0.22);
}

.dark\\:bg-\\[rgba\\(22\\2c 163\\2c 74\\2c 0\\.14\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(22,163,74,0.14);
}

.dark\\:bg-\\[rgba\\(220\\2c 38\\2c 38\\2c 0\\.12\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(220,38,38,0.12);
}

.dark\\:bg-\\[rgba\\(220\\2c 38\\2c 38\\2c 0\\.15\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(220,38,38,0.15);
}

.dark\\:bg-\\[rgba\\(220\\2c 38\\2c 38\\2c 0\\.16\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(220,38,38,0.16);
}

.dark\\:bg-\\[rgba\\(220\\2c 38\\2c 38\\2c 0\\.18\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(220,38,38,0.18);
}

.dark\\:bg-\\[rgba\\(220\\2c 38\\2c 38\\2c 0\\.2\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(220,38,38,0.2);
}

.dark\\:bg-\\[rgba\\(29\\2c 78\\2c 216\\2c 0\\.2\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(29,78,216,0.2);
}

.dark\\:bg-\\[rgba\\(34\\2c 197\\2c 94\\2c 0\\.12\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(34,197,94,0.12);
}

.dark\\:bg-\\[rgba\\(34\\2c 197\\2c 94\\2c 0\\.15\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(34,197,94,0.15);
}

.dark\\:bg-\\[rgba\\(60\\2c 135\\2c 247\\2c 0\\.16\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(60,135,247,0.16);
}

.dark\\:bg-panel:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: var(--surface-2);
}

.dark\\:text-\\[\\#4ade80\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-text-opacity: 1;
    color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#93bdfb\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-text-opacity: 1;
    color: rgb(147 189 251 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#a3a3a3\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-text-opacity: 1;
    color: rgb(163 163 163 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#c4b5fd\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-text-opacity: 1;
    color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#d4d4d4\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-text-opacity: 1;
    color: rgb(212 212 212 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#f5f5f5\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-text-opacity: 1;
    color: rgb(245 245 245 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#f87171\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-text-opacity: 1;
    color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#fbbf24\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-text-opacity: 1;
    color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#fca5a5\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-text-opacity: 1;
    color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:text-dim:where([data-theme="dark"], [data-theme="dark"] *) {
    color: var(--text-sub);
}

.dark\\:text-ink:where([data-theme="dark"], [data-theme="dark"] *) {
    color: var(--text);
}

.dark\\:shadow-\\[0_0_10px_rgba\\(245\\2c 245\\2c 245\\2c 0\\.55\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-shadow: 0 0 10px rgba(245,245,245,0.55);
    --tw-shadow-colored: 0 0 10px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-none:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:\\[border-color\\:rgba\\(220\\2c 38\\2c 38\\2c 0\\.4\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    border-color: rgba(220,38,38,0.4);
}

.dark\\:\\[border-top\\:1px_solid_rgba\\(255\\2c 255\\2c 255\\2c 0\\.06\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    border-top: 1px solid rgba(255,255,255,0.06);
}

.dark\\:\\[border\\:1px_solid_\\#242424\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    border: 1px solid #242424;
}

.dark\\:\\[filter\\:drop-shadow\\(0_30px_60px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    filter: drop-shadow(0 30px 60px rgba(0,0,0,0.5));
}

.dark\\:\\[text-shadow\\:0_0_12px_rgba\\(245\\2c 245\\2c 245\\2c 0\\.45\\)\\]:where([data-theme="dark"], [data-theme="dark"] *) {
    text-shadow: 0 0 12px rgba(245,245,245,0.45);
}

.dark\\:before\\:bg-\\[\\#333333\\]:where([data-theme="dark"], [data-theme="dark"] *)::before {
    content: var(--tw-content);
    --tw-bg-opacity: 1;
    background-color: rgb(51 51 51 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-\\[\\#242424\\]:hover:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-bg-opacity: 1;
    background-color: rgb(36 36 36 / var(--tw-bg-opacity, 1));
}

.dark\\:hover\\:bg-\\[rgba\\(220\\2c 38\\2c 38\\2c 0\\.16\\)\\]:hover:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: rgba(220,38,38,0.16);
}

.dark\\:hover\\:bg-surface:hover:where([data-theme="dark"], [data-theme="dark"] *) {
    background-color: var(--surface);
}

.dark\\:hover\\:text-\\[\\#e5e5e5\\]:hover:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-text-opacity: 1;
    color: rgb(229 229 229 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-ink:hover:where([data-theme="dark"], [data-theme="dark"] *) {
    color: var(--text);
}

.\\[\\&\\+\\&\\]\\:mt-\\[10px\\]+.\\[\\&\\+\\&\\]\\:mt-\\[10px\\] {
    margin-top: 10px;
}

.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
    display: none;
}

@media not all and (min-width: 768px) {
    .max-md\\:\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
        display: none;
    }
}

.\\[\\&\\:not\\(\\:first-child\\)\\]\\:ml-\\[-6px\\]:not(:first-child) {
    margin-left: -6px;
}

.\\[\\&\\:not\\(\\:first-child\\)\\]\\:mt-4:not(:first-child) {
    margin-top: 1rem;
}

.\\[\\&\\:not\\(\\:first-child\\)\\]\\:mt-\\[10px\\]:not(:first-child) {
    margin-top: 10px;
}

.\\[\\&\\:not\\(\\:first-child\\)\\]\\:\\[border-top\\:1px_solid_var\\(--table-line\\)\\]:not(:first-child) {
    border-top: 1px solid var(--table-line);
}

.\\[\\&\\:not\\(\\:first-of-type\\)\\]\\:mt-4:not(:first-of-type) {
    margin-top: 1rem;
}

.\\[\\&\\:not\\(\\:first-of-type\\)\\]\\:\\[border-top\\:1px_solid_var\\(--table-line\\)\\]:not(:first-of-type) {
    border-top: 1px solid var(--table-line);
}

.\\[\\&\\:not\\(\\:last-child\\)\\]\\:\\[border-bottom\\:1px_solid_var\\(--table-line\\)\\]:not(:last-child) {
    border-bottom: 1px solid var(--table-line);
}

.\\[\\&\\:not\\(\\:last-child\\)\\]\\:\\[border-right\\:1px_solid_var\\(--table-line\\)\\]:not(:last-child) {
    border-right: 1px solid var(--table-line);
}

@media (min-width: 768px) {
    .md\\:\\[\\&\\:nth-last-child\\(2\\)\\]\\:border-b-0:nth-last-child(2) {
        border-bottom-width: 0px;
    }
}

.\\[\\&\\>span\\]\\:flex-1>span {
    flex: 1 1 0%;
}

.\\[\\&\\>span\\]\\:rounded-t-\\[6px\\]>span {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
}

.\\[\\&\\>span\\]\\:bg-gradient-to-b>span {
    background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}

.\\[\\&\\>span\\]\\:from-\\[\\#5b9dff\\]>span {
    --tw-gradient-from: #5b9dff var(--tw-gradient-from-position);
    --tw-gradient-to: rgb(91 157 255 / 0) var(--tw-gradient-to-position);
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.\\[\\&\\>span\\]\\:to-\\[\\#3C87F7\\]>span {
    --tw-gradient-to: #3C87F7 var(--tw-gradient-to-position);
}

.\\[\\&\\>span\\]\\:opacity-90>span {
    opacity: 0.9;
}

.\\[\\&\\>svg\\]\\:h-4>svg {
    height: 1rem;
}

.\\[\\&\\>svg\\]\\:h-\\[18px\\]>svg {
    height: 18px;
}

.\\[\\&\\>svg\\]\\:h-\\[26px\\]>svg {
    height: 26px;
}

.\\[\\&\\>svg\\]\\:w-4>svg {
    width: 1rem;
}

.\\[\\&\\>svg\\]\\:w-\\[18px\\]>svg {
    width: 18px;
}

.\\[\\&\\>svg\\]\\:w-\\[26px\\]>svg {
    width: 26px;
}

.\\[\\&_\\*\\]\\:text-ink * {
    color: var(--text);
}

.\\[\\&_a\\:hover\\]\\:border-\\[\\#b4bcca\\] a:hover {
    --tw-border-opacity: 1;
    border-color: rgb(180 188 202 / var(--tw-border-opacity, 1));
}

.\\[\\&_a\\:hover\\]\\:text-\\[\\#0f172a\\] a:hover {
    --tw-text-opacity: 1;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.\\[\\&_a\\:hover\\]\\:text-\\[\\#cfcfcf\\] a:hover {
    --tw-text-opacity: 1;
    color: rgb(207 207 207 / var(--tw-text-opacity, 1));
}

.\\[\\&_a\\:hover\\]\\:underline a:hover {
    text-decoration-line: underline;
}

.\\[\\&_a\\]\\:inline-flex a {
    display: inline-flex;
}

.\\[\\&_a\\]\\:h-8 a {
    height: 2rem;
}

.\\[\\&_a\\]\\:w-8 a {
    width: 2rem;
}

.\\[\\&_a\\]\\:items-center a {
    align-items: center;
}

.\\[\\&_a\\]\\:justify-center a {
    justify-content: center;
}

.\\[\\&_a\\]\\:rounded-full a {
    border-radius: 9999px;
}

.\\[\\&_a\\]\\:border a {
    border-width: 1px;
}

.\\[\\&_a\\]\\:border-\\[\\#e6e9ef\\] a {
    --tw-border-opacity: 1;
    border-color: rgb(230 233 239 / var(--tw-border-opacity, 1));
}

.\\[\\&_a\\]\\:py-1 a {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}

.\\[\\&_a\\]\\:text-\\[13px\\] a {
    font-size: 13px;
}

.\\[\\&_a\\]\\:font-medium a {
    font-weight: 500;
}

.\\[\\&_a\\]\\:text-\\[\\#1D68D9\\] a {
    --tw-text-opacity: 1;
    color: rgb(29 104 217 / var(--tw-text-opacity, 1));
}

.\\[\\&_a\\]\\:text-\\[\\#64748b\\] a {
    --tw-text-opacity: 1;
    color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}

.\\[\\&_a\\]\\:text-\\[\\#8f8f8f\\] a {
    --tw-text-opacity: 1;
    color: rgb(143 143 143 / var(--tw-text-opacity, 1));
}

.\\[\\&_a\\]\\:text-\\[\\#94a3b8\\] a {
    --tw-text-opacity: 1;
    color: rgb(148 163 184 / var(--tw-text-opacity, 1));
}

.\\[\\&_a\\]\\:underline a {
    text-decoration-line: underline;
}

.\\[\\&_a\\]\\:underline-offset-\\[3px\\] a {
    text-underline-offset: 3px;
}

.\\[\\&_h2\\]\\:mb-3 h2 {
    margin-bottom: 0.75rem;
}

.\\[\\&_h2\\]\\:mt-10 h2 {
    margin-top: 2.5rem;
}

.\\[\\&_h2\\]\\:text-\\[22px\\] h2 {
    font-size: 22px;
}

.\\[\\&_h2\\]\\:font-semibold h2 {
    font-weight: 600;
}

.\\[\\&_h2\\]\\:tracking-\\[-0\\.01em\\] h2 {
    letter-spacing: -0.01em;
}

.\\[\\&_h2\\]\\:text-\\[\\#0f172a\\] h2 {
    --tw-text-opacity: 1;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.\\[\\&_h3\\]\\:mb-2 h3 {
    margin-bottom: 0.5rem;
}

.\\[\\&_h3\\]\\:mt-\\[26px\\] h3 {
    margin-top: 26px;
}

.\\[\\&_h3\\]\\:text-\\[17px\\] h3 {
    font-size: 17px;
}

.\\[\\&_h3\\]\\:font-semibold h3 {
    font-weight: 600;
}

.\\[\\&_h3\\]\\:text-\\[\\#0f172a\\] h3 {
    --tw-text-opacity: 1;
    color: rgb(15 23 42 / var(--tw-text-opacity, 1));
}

.\\[\\&_li\\]\\:mb-1\\.5 li {
    margin-bottom: 0.375rem;
}

.\\[\\&_li\\]\\:text-\\[15px\\] li {
    font-size: 15px;
}

.\\[\\&_li\\]\\:leading-\\[1\\.7\\] li {
    line-height: 1.7;
}

.\\[\\&_li\\]\\:text-\\[\\#334155\\] li {
    --tw-text-opacity: 1;
    color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.\\[\\&_p\\]\\:mb-\\[14px\\] p {
    margin-bottom: 14px;
}

.\\[\\&_p\\]\\:text-\\[15px\\] p {
    font-size: 15px;
}

.\\[\\&_p\\]\\:leading-\\[1\\.7\\] p {
    line-height: 1.7;
}

.\\[\\&_p\\]\\:text-\\[\\#334155\\] p {
    --tw-text-opacity: 1;
    color: rgb(51 65 85 / var(--tw-text-opacity, 1));
}

.group.sidebar-collapsed .group-\\[\\.sidebar-collapsed\\]\\:\\[\\&_span\\]\\:hidden span {
    display: none;
}

.\\[\\&_svg\\]\\:h-4 svg {
    height: 1rem;
}

.\\[\\&_svg\\]\\:h-\\[12px\\] svg {
    height: 12px;
}

.\\[\\&_svg\\]\\:h-\\[13px\\] svg {
    height: 13px;
}

.\\[\\&_svg\\]\\:h-\\[14px\\] svg {
    height: 14px;
}

.\\[\\&_svg\\]\\:h-\\[15px\\] svg {
    height: 15px;
}

.\\[\\&_svg\\]\\:h-\\[16px\\] svg {
    height: 16px;
}

.\\[\\&_svg\\]\\:h-\\[17px\\] svg {
    height: 17px;
}

.\\[\\&_svg\\]\\:h-\\[18px\\] svg {
    height: 18px;
}

.\\[\\&_svg\\]\\:w-4 svg {
    width: 1rem;
}

.\\[\\&_svg\\]\\:w-\\[12px\\] svg {
    width: 12px;
}

.\\[\\&_svg\\]\\:w-\\[13px\\] svg {
    width: 13px;
}

.\\[\\&_svg\\]\\:w-\\[14px\\] svg {
    width: 14px;
}

.\\[\\&_svg\\]\\:w-\\[15px\\] svg {
    width: 15px;
}

.\\[\\&_svg\\]\\:w-\\[16px\\] svg {
    width: 16px;
}

.\\[\\&_svg\\]\\:w-\\[17px\\] svg {
    width: 17px;
}

.\\[\\&_svg\\]\\:w-\\[18px\\] svg {
    width: 18px;
}

.\\[\\&_svg\\]\\:flex-none svg {
    flex: none;
}

.\\[\\&_svg\\]\\:text-\\[\\#18181b\\] svg {
    --tw-text-opacity: 1;
    color: rgb(24 24 27 / var(--tw-text-opacity, 1));
}

.\\[\\&_svg\\]\\:text-\\[\\#78716c\\] svg {
    --tw-text-opacity: 1;
    color: rgb(120 113 108 / var(--tw-text-opacity, 1));
}

.\\[\\&_svg\\]\\:transition-colors svg {
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}

.\\[\\&_svg\\]\\:duration-200 svg {
    transition-duration: 200ms;
}

.\\[\\&_svg\\]\\:\\[stroke-width\\:1\\.5px\\] svg {
    stroke-width: 1.5px;
}

.dark\\:\\[\\&_svg\\]\\:text-\\[\\#f5f5f5\\] svg:where([data-theme="dark"], [data-theme="dark"] *) {
    --tw-text-opacity: 1;
    color: rgb(245 245 245 / var(--tw-text-opacity, 1));
}

.\\[\\&_ul\\]\\:mb-4 ul {
    margin-bottom: 1rem;
}

.\\[\\&_ul\\]\\:pl-5 ul {
    padding-left: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/tailwind.css"],"names":[],"mappings":"AAAA;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;EAAd;;;;IAAA,qBAAc;SAAd,gBAAc;IAAd,wBAAc;IAAd,6BAAc;IAAd,sBAAc;IAAd,eAAc;IAAd,mBAAc;IAAd,0BAAc;IAAd,cAAc;IAAd,eAAc;EAAA;;EAAd,yEAAc;EAAd;;IAAA,eAAc;IAAd,mBAAc;IAAd,2BAAc;EAAA;;EAAd;IAAA,qBAAc;SAAd,gBAAc;IAAd,wBAAc;EAAA;EAAd;;IAAA,wBAAc;EAAA;AACd;IAAA;AAAoB;AAApB;IAAA;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;AAAA;AAApB;IAAA;QAAA;IAAoB;AAAA;AACpB;IAAA,kBAAmB;IAAnB,UAAmB;IAAnB,WAAmB;IAAnB,UAAmB;IAAnB,YAAmB;IAAnB,gBAAmB;IAAnB,sBAAmB;IAAnB,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,SAAmB;IAAnB;AAAmB;AAAnB;IAAA,QAAmB;IAAnB;AAAmB;AAAnB;IAAA,QAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB,oBAAmB;IAAnB,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,8CAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,eAAmB;IAAnB,eAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA,eAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA,2BAAmB;QAAnB;IAAmB;IAAnB;QAAA,eAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yBAAmB;OAAnB,sBAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,wBAAmB;OAAnB,qBAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yBAAmB;SAAnB;AAAmB;AAAnB;IAAA,wBAAmB;SAAnB;AAAmB;AAAnB;IAAA,yBAAmB;SAAnB;AAAmB;AAAnB;IAAA,uBAAmB;SAAnB;AAAmB;AAAnB;IAAA,yBAAmB;SAAnB;AAAmB;AAAnB;IAAA,wBAAmB;SAAnB;AAAmB;AAAnB;IAAA,qBAAmB;SAAnB;AAAmB;AAAnB;IAAA,wBAAmB;SAAnB;AAAmB;AAAnB;IAAA,uBAAmB;SAAnB;AAAmB;AAAnB;IAAA,qBAAmB;SAAnB;AAAmB;AAAnB;IAAA,wBAAmB;SAAnB;AAAmB;AAAnB;IAAA,qBAAmB;SAAnB;AAAmB;AAAnB;IAAA,qBAAmB;SAAnB;AAAmB;AAAnB;IAAA,qBAAmB;SAAnB;AAAmB;AAAnB;IAAA,qBAAmB;SAAnB;AAAmB;AAAnB;IAAA,qBAAmB;SAAnB;AAAmB;AAAnB;IAAA,oBAAmB;SAAnB;AAAmB;AAAnB;IAAA,oBAAmB;SAAnB;AAAmB;AAAnB;IAAA,oBAAmB;SAAnB;AAAmB;AAAnB;IAAA,oBAAmB;SAAnB;AAAmB;AAAnB;IAAA,oBAAmB;SAAnB;AAAmB;AAAnB;IAAA,oBAAmB;SAAnB;AAAmB;AAAnB;IAAA,oBAAmB;SAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB,uBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,4DAAmB;IAAnB,qEAAmB;IAAnB;AAAmB;AAAnB;IAAA,4DAAmB;IAAnB,qEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sBAAmB;OAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,iBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA,gBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,qBAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0EAAmB;IAAnB,8FAAmB;IAAnB;AAAmB;AAAnB;IAAA,gDAAmB;IAAnB,8DAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,sCAAmB;IAAnB,oDAAmB;IAAnB;AAAmB;AAAnB;IAAA,wCAAmB;IAAnB,mDAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,4CAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,4CAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,0CAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,8CAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,yEAAmB;IAAnB,8FAAmB;IAAnB;AAAmB;AAAnB;IAAA,gFAAmB;IAAnB,+FAAmB;IAAnB;AAAmB;AAAnB;IAAA,0CAAmB;IAAnB,qDAAmB;IAAnB;AAAmB;AAAnB;IAAA,0CAAmB;IAAnB,qDAAmB;IAAnB;AAAmB;AAAnB;IAAA,0EAAmB;IAAnB,uFAAmB;IAAnB;AAAmB;AAAnB;IAAA,+CAAmB;IAAnB,6DAAmB;IAAnB;AAAmB;AAAnB;IAAA,4CAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,wCAAmB;IAAnB,sDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+CAAmB;IAAnB,6DAAmB;IAAnB;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB,kCAAmB;IAAnB;AAAmB;AAAnB;IAAA,0CAAmB;IAAnB,uDAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2GAAmB;IAAnB,yGAAmB;IAAnB;AAAmB;AAAnB;IAAA,2GAAmB;IAAnB,yGAAmB;IAAnB;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,sBAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,qCAAmB;IAAnB;AAAmB;AAAnB;IAAA,wJAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,4DAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,kEAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,sDAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,4CAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,qCAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,sCAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,yBAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,uCAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,qEAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,sCAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,6CAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,sCAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,2CAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,oCAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+FAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB,wDAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;;AAEnB;;;;;;gDAMgD;;AAVhD;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,0BA4CA;IA5CA;AA4CA;;AA5CA;IAAA,0BA4CA;IA5CA;AA4CA;;AA5CA;IAAA,0BA4CA;IA5CA;AA4CA;;AA5CA;IAAA,0BA4CA;IA5CA;AA4CA;;AA5CA;IAAA,0BA4CA;IA5CA;AA4CA;;AA5CA;IAAA,0BA4CA;IA5CA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,gBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,2CA4CA;IA5CA,qDA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,sBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,sBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,2CA4CA;IA5CA,sDA4CA;IA5CA;AA4CA;;AA5CA;IAAA,2CA4CA;IA5CA,sDA4CA;IA5CA;AA4CA;;AA5CA;IAAA,2CA4CA;IA5CA,sDA4CA;IA5CA;AA4CA;;AA5CA;IAAA,gCA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,2CA4CA;IA5CA,qDA4CA;IA5CA;AA4CA;;AA5CA;IAAA,8BA4CA;IA5CA;AA4CA;;AA5CA;IAAA,2GA4CA;IA5CA,yGA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,qBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,qBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,0BA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,oBA4CA;SA5CA;AA4CA;;AA5CA;IAAA,iBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;QAAA,qBA4CA;QA5CA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA,uBA4CA;aA5CA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA,qBA4CA;QA5CA;IA4CA;IA5CA;QAAA,kBA4CA;QA5CA;IA4CA;IA5CA;QAAA,iBA4CA;QA5CA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA,oBA4CA;QA5CA;IA4CA;IA5CA;QAAA,kBA4CA;QA5CA;IA4CA;IA5CA;QAAA,iBA4CA;QA5CA;IA4CA;IA5CA;QAAA,iBA4CA;QA5CA;IA4CA;IA5CA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA,sBA4CA;QA5CA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA,0BA4CA;QA5CA;IA4CA;IA5CA;QAAA,0BA4CA;QA5CA;IA4CA;IA5CA;QAAA,0BA4CA;QA5CA;IA4CA;IA5CA;QAAA,0BA4CA;QA5CA;IA4CA;IA5CA;QAAA,0BA4CA;QA5CA;IA4CA;IA5CA;QAAA,0BA4CA;QA5CA;IA4CA;IA5CA;QAAA,0BA4CA;QA5CA,kBA4CA;QA5CA;IA4CA;IA5CA;QAAA,0BA4CA;QA5CA,2BA4CA;QA5CA,qDA4CA;QA5CA;IA4CA;IA5CA;QAAA,gBA4CA;QA5CA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;IA5CA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,4CA4CA;IA5CA,oDA4CA;IA5CA;AA4CA;;AA5CA;IAAA,sBA4CA;IA5CA,8BA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,0BA4CA;IA5CA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,kBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;QAAA;IA4CA;AAAA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,2BA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,4DA4CA;IA5CA,oEA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,sBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,sBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA,+FA4CA;IA5CA,wDA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA,oBA4CA;IA5CA;AA4CA;;AA5CA;IAAA;AA4CA;;AA5CA;IAAA;AA4CA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Preflight is disabled (the legacy styles.css still styles unconverted pages),\n   so native form-control chrome — the 2px \"outset\" button border, the native\n   search-field look — leaks through on Tailwind-migrated components. Re-add just\n   the control normalization preflight would provide. Kept in @layer base so it\n   sits below utilities and below the unlayered styles.css, meaning any element\n   that sets its own border (legacy .btn-ghost, .search, .region-select select,\n   or a Tailwind `border` utility) still wins. */\n@layer base {\n  button,\n  [type='button'],\n  [type='reset'],\n  [type='submit'] {\n    appearance: none;\n    -webkit-appearance: none;\n    background-color: transparent;\n    background-image: none;\n    border-width: 0;\n    border-style: solid;\n    border-color: currentColor;\n    color: inherit;\n    cursor: pointer;\n  }\n\n  /* Flatten native text/search inputs; the design draws its own borders. */\n  input:not([type='checkbox']):not([type='radio']),\n  textarea {\n    border-width: 0;\n    border-style: solid;\n    border-color: var(--border);\n  }\n\n  [type='search'] {\n    appearance: none;\n    -webkit-appearance: none;\n  }\n  [type='search']::-webkit-search-decoration,\n  [type='search']::-webkit-search-cancel-button {\n    -webkit-appearance: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
